// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-29T18:36:08.978Z
// Property: The Forum (ID: 6767906449167571)
// Collections: 16 amenities, 3 floorplans (live), 54 photos, 45 POIs, 6 office hours, 1 special offers (live), 20 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162464",
  "multihub_property_id": "6767906449167571",
  "property_external_id": "1955235",
  "property_zillow_url": "https://www.zillow.com/apartments/covington-ga/the-forum/CkZjsk/",
  "property_apartments_url": "https://www.apartments.com/the-forum-covington-ga/4nlxntj/",
  "property_google_business_url": "https://www.google.com/maps/place/The+Forum+-+by+Quinn+Residences/@33.622119,-83.844093,953m/data=!3m2!1e3!4b1!4m6!3m5!1s0x88f433cd9db205ef:0x287b78b3dfd0e4ff!8m2!3d33.622119!4d-83.844093!16s%2Fg%2F11yrbt1sc2?entry=ttu&g_ep=EgoyMDI2MDkyOC4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": "57159798433",
  "property_crm_software": "RentCafe Yardi",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-forum",
  "property_name": "The Forum",
  "property_website_url": "https://www.live-forum.com/",
  "property_domain": "https://www.live-forum.com/",
  "property_address": "12250 Town Center Blvd",
  "property_full_address": "12250 Town Center Blvd, Covington, GA 30014",
  "property_address_1": "12250 Town Center Blvd",
  "property_address_2": null,
  "property_address_city": "Covington",
  "property_address_state": "GA",
  "property_address_zip_full": "30014",
  "property_address_zip": "30014",
  "property_address_country": "US",
  "property_address_county": "Newton County",
  "property_neighborhood_address": "Newton County",
  "property_address_latitude": "33.622119",
  "property_address_longitude": "-83.844093",
  "property_email": "covhub@quinnmgmt.com",
  "property_phone": "(762) 525-6276",
  "property_call_tracking_phone": "762-525-6276",
  "property_company_name": "Quinn Residences",
  "property_company_url": "https://www.quinnmgmt.com",
  "agency_contacts": null,
  "property_type": "Townhomes",
  "property_short_description": "<p><strong>Modern townhome living in Covington Town Center.</strong> The Forum pairs spacious three- and four-bedroom rentals with polished finishes, smart-home comfort, and maintained-community ease near I-20. Compare <a href=\"/floor-plans\">available floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> today.</p>",
  "property_long_description": "<p><strong>Modern townhome living in Covington Town Center.</strong> At The Forum, you get the space of a three- or four-bedroom townhome with the ease of a professionally maintained rental community. Inside, stainless steel appliances, granite countertops, luxury flooring, spacious closets, smart-home technology, and in-unit laundry bring everyday comfort into focus; outside, a clubhouse, pool, firepit, gas grills, dog park, lawn care, and a security deposit alternative add flexibility where it matters. Explore the full mix of <a href=\"/amenities\">community and home features</a> or compare <a href=\"/floor-plans\">available floor plans</a>.</p><p>Set within Covington’s growing Town Center district near I-20, The Forum keeps shopping, dining, and errands close, including the Publix-anchored retail center nearby. When you want more local flavor, Downtown Covington Square, Mystic Grill, Bread and Butter Bakery &amp; Café, Turner Lake Complex, Chimney Park, Georgia International Horse Park, and Hard Labor Creek State Park are all within reach. See more on the <a href=\"/neighborhood\">neighborhood</a> page or schedule a tour when you’re ready.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-200a-7089-a915-f6739636d3e5.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior of a multifamily building with a covered entrance and walkway.",
    "public_id": "019fae2a-200a-7089-a915-f6739636d3e5",
    "storage_key": "property/6767906449167571/019fae2a-200a-7089-a915-f6739636d3e5.webp",
    "width": 1280,
    "height": 900
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449167571/01a0c02a-8ff7-775d-b07c-261b7541c917.mp4",
  "property_featured_video_media": {
    "public_id": "01a0c02a-8ff7-775d-b07c-261b7541c917",
    "storage_key": "property/6767906449167571/01a0c02a-8ff7-775d-b07c-261b7541c917.mp4",
    "thumbnail_key": "property/6767906449167571/01a0c02a-8ff7-775d-b07c-261b7541c917_thumb.webp",
    "size_bytes": 18840147,
    "classification": "Community",
    "title": "The Forum Apartments: Community Amenities and Exterior Tour",
    "description": "Explore the exterior of The Forum apartments and its impressive community amenities, including the pool and outdoor lounge areas. See the overall property and townhome exteriors."
  },
  "property_total_units": "68",
  "property_year_built": "2025",
  "property_year_renovated": null,
  "property_walk_score": "17",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "83.82352941176471",
  "property_admin_fee": "350",
  "property_application_fee": "100",
  "property_fees_deposit_info": "Security deposit varies with application screening; a security deposit alternative is available. Required monthly charges: utility billing $11.99, concierge package $10.95, landscaping $45, smart home package $35, valet trash $25; renters insurance required. Application fee $100 per adult applicant; administrative fee $350 (one-time). See the Easy Fee Guide for the full schedule.",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "100",
  "property_pet_restrictions": "Restricted breeds include Pit Bull, Rottweiler, Cane Corso, American Staffordshire Terrier, Bull Terrier, and American Bulldog, or any crossbreeds of these. Maximum weight limit of 100 pounds per pet; no more than two pets without written approval. Pet screening is required before move-in.",
  "property_pet_policy_description": "Dogs and cats welcome, up to two pets. One-time pet fee $300 for one pet, $500 for two. Pet rent $35 per pet per month. 100-lb weight limit and breed restrictions apply; pet screening required.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://live-forum.securecafe.com/onlineleasing/the-forum0/floorplans.aspx",
  "property_resident_portal_url": "https://live-forum.securecafenet.com/residentservices/the-forum0/userlogin",
  "property_apply_now_url": "https://live-forum.securecafe.com/onlineleasing/the-forum0/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bd-7e05-70f5-a887-a461037ea182.webp",
  "property_primary_logo_media": {
    "alt_text": "The Forum by Quinn Residences logo",
    "public_id": "019fa9bd-7e05-70f5-a887-a461037ea182",
    "storage_key": "property/6767906449167571/019fa9bd-7e05-70f5-a887-a461037ea182.webp",
    "width": 150,
    "height": 64
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bd-c39f-777a-afca-c7266a945cea.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019fa9bd-c39f-777a-afca-c7266a945cea",
    "storage_key": "property/6767906449167571/019fa9bd-c39f-777a-afca-c7266a945cea.webp",
    "width": 150,
    "height": 64
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bd-b770-71fd-92de-0cba8836032a.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019fa9bd-b770-71fd-92de-0cba8836032a",
    "storage_key": "property/6767906449167571/019fa9bd-b770-71fd-92de-0cba8836032a.webp",
    "width": 150,
    "height": 64
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/01a0abc9-4cac-75ae-8a34-d20271f4bca8.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/019fa983-2459-730d-9320-edaae039913a.webp",
  "property_company_logo_media": {
    "alt_text": "Quinn Residences logo",
    "public_id": "019fa983-2459-730d-9320-edaae039913a",
    "storage_key": "company/5767906449162464/019fa983-2459-730d-9320-edaae039913a.webp",
    "width": 2161,
    "height": 964
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/019fa983-24c1-74dc-8eb8-8eb0b71b3a84.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Quinn Residences logo.",
    "public_id": "019fa983-24c1-74dc-8eb8-8eb0b71b3a84",
    "storage_key": "company/5767906449162464/019fa983-24c1-74dc-8eb8-8eb0b71b3a84.webp",
    "width": 2161,
    "height": 964
  },
  "property_primary_color": "#337b8c",
  "property_secondary_color": "#5e411e",
  "property_font_color": "#606161",
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "3 - 4",
  "property_bedrooms_min": "3",
  "property_bedrooms_max": "4",
  "property_bathrooms_range": "2.5 - 2.5",
  "property_bathrooms_min": "2.5",
  "property_bathrooms_max": "2.5",
  "property_sqft_range": "1833 - 1854",
  "property_sqft_min": "1833",
  "property_sqft_max": "1854",
  "property_price_range": "2100 - 2448",
  "property_price_min": "2100",
  "property_price_max": "2541",
  "property_available_units": 10,
  "property_facebook_url": "https://www.facebook.com/profile.php?id=61575614580319",
  "property_instagram_url": "https://www.instagram.com/live_theforum",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ7wWync0z9IgR_-TQ37N4eyg",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to The Forum",
  "property_home_romance_title": "Embrace the Joy of Living in Your Ideal Townhome",
  "property_home_amenities_blurb": "<p><strong>Everyday ease, built in.</strong> The Forum pairs townhome-style living with smart-home features, in-unit laundry, lawn maintenance, and polished finishes like granite countertops, stainless steel appliances, luxury flooring, and spacious closets. Beyond your front door, relax by the pool, gather at the firepit, grill outdoors, or let pets stretch out at the dog park.</p>",
  "property_home_floorplans_blurb": "<p><strong>Townhome-style space, streamlined choices.</strong> Explore a focused collection of three- and four-bedroom floor plans at The Forum in Covington, with open living areas, generous closets, in-unit laundry, and polished finishes like granite countertops, stainless steel appliances, luxury flooring, and smart-home technology. Compare layouts, pricing, and availability, then find the plan that fits your next move.</p>",
  "property_home_gallery_blurb": "<p><strong>Get a closer look at The Forum.</strong> Preview Covington townhome living with bright kitchens, stainless steel appliances, granite countertops, luxury flooring, and smart-home touches. Then browse outdoor spaces made for fresh-air downtime, including the pool, clubhouse, firepit, grilling areas, and dog park.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Covington starts right outside your door.</strong> From The Forum’s Town Center setting, everyday stops are close, I-20 is easy to reach from Alcovy Road, and the Square brings local dining, coffee, boutiques, and Covington’s signature film-tour charm. Add nights at Porter Performing Arts Center and outdoor time at City Pond Park, Turner Lake, or Georgia International Horse Park—and there’s always more to explore nearby.</p>",
  "property_home_reviews_blurb": "<p><strong>Resident feedback says it best.</strong> Get a quick feel for life at The Forum through ratings and comments from people who know the community firsthand. See what stands out, compare everyday impressions, and read more reviews to help guide your next move with confidence.</p>",
  "property_neighborhood_blurb": "<p><strong>Start close, then branch out.</strong> From The Forum’s Town Center setting, your map opens to a Covington routine that’s both convenient and full of local texture. Grab groceries and everyday stops around Covington Town Center, hop on I-20 from Alcovy Road, or head toward the Square for dinner, coffee, boutiques, and the city’s well-known film-tour atmosphere. Nights out can mean a performance at Porter Performing Arts Center; fresh-air time can point you toward City Pond Park, Turner Lake, or the trails and events around Georgia International Horse Park. Use the interactive map to explore what’s nearby, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how the location fits your week.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that smooth out the everyday.</strong> At The Forum, your routine gets more room to breathe, from smart-home features and in-unit laundry inside your townhome-style layout to lawn maintenance that helps keep weekends easier. Polished finishes like granite countertops, stainless steel appliances, luxury flooring, and spacious closets give each home a clean, current feel without sacrificing practicality.</p><p>Outside, the community spaces add a welcome change of pace: cool off at the pool, meet up around the firepit, grill dinner outdoors, or give your dog room to roam at the dog park. Browse the <a href=\"/gallery\">photo gallery</a> for a closer look, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how these Covington amenities fit your day.</p>",
  "property_applynow_blurb": "<p><strong>Start your application at The Forum.</strong> Choose modern three- or four-bedroom townhome space with professional maintenance, smart-home technology, in-unit laundry, and everyday finishes that feel move-in ready. If The Forum feels like the right fit, apply online today and take the next step toward your new Covington Town Center home.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong> Contact The Forum leasing team to learn more about modern three- and four-bedroom townhome living in Covington Town Center, from available layouts to everyday community conveniences. We’re here to help you plan your next step.</p>",
  "property_faqs_blurb": "<p><strong>Questions about The Forum?</strong> Start here for quick answers about our modern three- and four-bedroom townhome rental community in Covington Town Center, including leasing, community features, and everyday living. If you need more details, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Choose the room that fits how you live.</strong> The Forum’s floor plans give you a focused lineup of spacious three- and four-bedroom townhome-style layouts in Covington, each designed with open living areas, generous closets, and the everyday convenience of in-unit laundry.</p><p>Compare the Danielson, Darcy, and Dylan plans side by side to find the bedroom count, layout flow, pricing, and availability that work best for your next move. Inside, <a href=\"/amenities\">granite countertops, stainless steel appliances, luxury flooring, and smart-home technology</a> add a polished feel without overcomplicating your day. Browse the available floor plan cards, check current openings, then <a href=\"/schedule-a-tour\">schedule a tour</a> when you’re ready to see the space in person.</p>",
  "property_gallery_blurb": "<p><strong>See the spaces take shape.</strong> Browse The Forum’s photo gallery for a closer look at the finishes, gathering areas, and outdoor details that define this Covington townhome community. Picture a bright kitchen with stainless steel appliances and granite countertops, an open living area grounded by luxury flooring, and smart-home details that make each layout feel current.</p><p>Then step outside through the images: the pool on a sunny afternoon, the clubhouse ready for a change of scenery, the firepit and grills set up for easy outdoor time, and the dog park adding another view of everyday convenience. After you explore the gallery, compare <a href=\"/floor-plans\">townhome-style floor plans</a>, view more <a href=\"/amenities\">home and community features</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see it all in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore The Forum on the map.</strong> Browse available three- and four-bedroom townhomes, then zoom out to see how Covington Town Center, nearby shopping and dining, daily errands, and I-20 access fit around your next address.</p>",
  "property_pets_blurb": "<p><strong>Room for paws, zoomies, and easy daily routines.</strong> At The Forum, cats and dogs can feel at home alongside you, with townhome-style layouts that give pet gear, beds, and favorite sunny spots a little more breathing room. Step outside for quick fresh-air breaks, spend time at the on-site dog park, or enjoy a community setting where lawn maintenance helps keep the grounds cared for without adding to your weekend list.</p><p>Inside, features like luxury flooring, spacious closets, and in-unit laundry help make pet-friendly living feel more practical day to day. Want to picture the flow before you visit? Explore the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how life with your pet fits at The Forum in Covington.</p>",
  "property_referafriend_blurb": "<p><strong>Love life at The Forum?</strong> Share it. Invite friends to discover modern three- and four-bedroom townhome living in Covington Town Center, with spacious interiors, smart-home comfort, and a professionally maintained community. Send a referral today and help them picture their next move here.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at The Forum.</strong><br>Log in to pay rent, submit maintenance requests, and manage your account with ease—part of the everyday convenience of a professionally maintained townhome community in Covington Town Center.</p>",
  "property_reviews_blurb": "<p><strong>See The Forum through resident feedback.</strong> As you compare your options, the reviews on this page offer a firsthand look at everyday living here. Browse the full list of ratings and comments to see what stands out, what questions come up, and how real resident experiences can help you feel more confident about your next step.</p>",
  "property_created_at": "1785259033593",
  "property_scheduletour_blurb": "<p><strong>See townhome living in person.</strong> Tour The Forum and get a closer look at spacious three- and four-bedroom layouts, modern finishes, smart-home touches, and the professionally maintained community spaces that make everyday living feel easy. Schedule your visit today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you — your inquiry has been received.</strong><br>Our leasing team will follow up soon with next steps. In the meantime, picture modern townhome living in Covington Town Center, with three- and four-bedroom layouts, stylish finishes, smart-home comfort, and professionally maintained spaces designed to make everyday living feel easy.</p>",
  "property_virtualtours_blurb": null,
  "property_copyright": "2026 All Rights Reserved. The Forum",
  "property_seo_title_home": "Townhomes for Rent in Covington, GA | The Forum",
  "property_seo_description_home": "Discover luxury 3- and 4-bedroom townhomes for rent in Covington, GA, with smart-home technology and modern finishes. Explore The Forum today!",
  "property_seo_title_floorplans": "3 & 4 Bedroom Townhomes in Covington, GA",
  "property_seo_description_floorplans": "Explore spacious 3- and 4-bedroom townhomes in Covington, GA, with modern kitchens, in-unit laundry, and smart-home features. Find your floor plan!",
  "property_seo_title_amenities": "Covington, GA Townhome Amenities | The Forum",
  "property_seo_description_amenities": "Enjoy smart-home technology, in-unit laundry, stainless steel appliances, and access to a pool and clubhouse at The Forum. Explore our amenities!",
  "property_seo_title_gallery": "Townhome Photos in Covington, GA | The Forum",
  "property_seo_description_gallery": "Browse photos of The Forum's luxury townhomes in Covington, GA. Explore spacious interiors, modern finishes, and community amenities.",
  "property_seo_title_virtualtours": "Virtual Tours of Covington, GA Townhomes",
  "property_seo_description_virtualtours": "Take a virtual tour of The Forum's 3- and 4-bedroom townhomes in Covington, GA. Explore spacious layouts and modern interiors from anywhere!",
  "property_seo_title_interactivemap": "Explore Available Townhomes in Covington, GA",
  "property_seo_description_interactivemap": "Explore available townhomes at The Forum in Covington, GA. View floor plans, compare layouts, and find a home that fits your needs.",
  "property_seo_title_neighborhood": "Townhomes Near Covington Town Center | The Forum",
  "property_seo_description_neighborhood": "Explore townhomes near Covington Town Center, local dining, shopping, parks, and I-20. Discover the neighborhood surrounding The Forum!",
  "property_seo_title_contact": "Contact The Forum | Covington, GA Townhomes",
  "property_seo_description_contact": "Have questions about The Forum's townhomes for rent in Covington, GA? Contact our leasing team to learn about availability, floor plans, and tours.",
  "property_seo_title_faqs": "FAQs | Apartments in Covington, GA",
  "property_seo_description_faqs": "Uncover your ideal lifestyle at The Forum in Covington, GA. From luxury amenities to spacious floor plans, our FAQs page has all the answers you need!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Covington, GA",
  "property_seo_description_reviews": "Join the vibrant life at The Forum in Covington, GA! Enjoy luxury amenities and spacious floor plans. Check out our residents' rave reviews today!",
  "property_seo_title_applynow": "Apply for a Townhome in Covington, GA | The Forum",
  "property_seo_description_applynow": "Ready to make The Forum your new home? Apply online for a spacious 3- or 4-bedroom townhome in Covington, GA. Start your application today!",
  "property_seo_title_residentaccess": "Resident Portal | The Forum Covington, GA",
  "property_seo_description_residentaccess": "Access The Forum's resident portal to manage your rental account, submit maintenance requests, and find helpful resident resources online.",
  "property_seo_title_referafriend": "Refer A Friend | The Forum",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to The Forum in Covington, GA, and enjoy vibrant living and community perks together!",
  "property_seo_title_scheduletour": "Tour Townhomes in Covington, GA | The Forum",
  "property_seo_description_scheduletour": "Experience The Forum's 3- and 4-bedroom townhomes in Covington, GA. Explore modern features and spacious layouts. Schedule your tour today!",
  "property_seo_title_privacy": "Privacy Policy | The Forum",
  "property_seo_description_privacy": "At The Forum in Covington, GA, your privacy matters. Learn how we protect your data and ensure a secure living environment. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | The Forum",
  "property_seo_description_accessibility": "Join us at The Forum in Covington, GA, as we prioritize digital inclusion with accessible features for a welcoming online experience!",
  "property_seo_title_sitemap": "Sitemap | The Forum",
  "property_seo_description_sitemap": "Navigate The Forum in Covington, GA, with our comprehensive sitemap! Find your ideal apartment home and embrace vibrant community living today.",
  "property_seo_title_thankyou": "Thank You for Contacting The Forum",
  "property_seo_description_thankyou": "Thank you for contacting The Forum in Covington, GA! Our leasing team will be in touch soon. Continue exploring our townhomes and amenities.",
  "property_seo_title_pets": "Pet-Friendly Townhomes in Covington, GA",
  "property_seo_description_pets": "Discover pet-friendly townhomes in Covington, GA, at The Forum. Explore our pet policy, spacious layouts, and access to a community dog park!",
  "property_updated_at": "1793287774847",
  "amenities": [
    {
      "id": "ec_a7269b648a0d814a42a666e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "yardi",
      "external_id": "125951458",
      "title": "Recreation Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6f18203b7d92b49f4e72d10d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "yardi",
      "external_id": "125951457",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8ba8d274d729ae54f312a5f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "yardi",
      "external_id": "125951455",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_244ec31c61a9f782321372f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "yardi",
      "external_id": "125951456",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8cf26bddcda36d617d30888e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "yardi",
      "external_id": "123660384",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fc85cbf1c292ef325c4460aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "yardi",
      "external_id": "123660382",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ce8713286b7bb2c2ab28b4b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "yardi",
      "external_id": "125951467",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bf367e7e1b0d9e9451805b06",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "yardi",
      "external_id": "125951466",
      "title": "Electronic Thermostat",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_921152fc4e70d1cd4d81afa4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "yardi",
      "external_id": "125951465",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6195a97aad977f04d2d24330",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "yardi",
      "external_id": "125951464",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_00b66f06c04e4e4d0afe6f17",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "yardi",
      "external_id": "125951463",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c8f4278f3d47893831fd4db9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "yardi",
      "external_id": "125951462",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2b72d6c1f53eff7c55a76e9f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "yardi",
      "external_id": "125951460",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0f6348d48fd9dde3c1fc1bf6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "yardi",
      "external_id": "125951461",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_30ce8c574ae45a28df8cd076",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "yardi",
      "external_id": "125951459",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_396c35bcb0b2790b123cf260",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "yardi",
      "external_id": "125951468",
      "title": "2-car Garage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_6e4d94e12ff4c6e3258134c8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-200a-7089-a915-f6739636d3e5.webp",
      "image_media": {
        "alt_text": "Exterior of a multifamily building with a covered entrance and walkway.",
        "public_id": "019fae2a-200a-7089-a915-f6739636d3e5",
        "storage_key": "property/6767906449167571/019fae2a-200a-7089-a915-f6739636d3e5.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Community",
      "description": "Charming exterior view of the multifamily property, featuring a welcoming covered entrance and well-maintained grounds.",
      "link": "false",
      "alt_text": "A two-story residential building with a front yard and a clear sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/The%20Forum%20-%20Darcy%20-%20Exterior.jpg"
    },
    {
      "id": "ec_5e780ef2aab744048a0bffce",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-580a-70ef-9077-fb2cf68eb5c6.webp",
      "image_media": {
        "alt_text": "Exterior view of townhome buildings with beige siding, white trim, and stone accents.",
        "public_id": "019fae2a-580a-70ef-9077-fb2cf68eb5c6",
        "storage_key": "property/6767906449167571/019fae2a-580a-70ef-9077-fb2cf68eb5c6.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Community",
      "description": "Charming townhomes with a modern farmhouse design, featuring inviting front porches and well-maintained landscaping.",
      "link": "false",
      "alt_text": "A row of houses with a blue sky in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/The%20Forum%20-%20Darcy%20Exterior%20Row.jpg"
    },
    {
      "id": "ec_0c01756c03afb455ca73b5d2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-58bd-73bb-9e88-1a6b601d8b70.webp",
      "image_media": {
        "alt_text": "Exterior view of a row of townhouses with garages on a sunny day.",
        "public_id": "019fae2a-58bd-73bb-9e88-1a6b601d8b70",
        "storage_key": "property/6767906449167571/019fae2a-58bd-73bb-9e88-1a6b601d8b70.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Community",
      "description": "Modern townhomes featuring attached garages and well-maintained landscaping, set against a clear blue sky.",
      "link": "false",
      "alt_text": "A row of houses with garages in front.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/The%20Forum%20-%20Dylan%20-%20Exterior.jpg"
    },
    {
      "id": "ec_595ddef029ed2da12b49f5ca",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-580f-77cb-84b7-160a1913fc30.webp",
      "image_media": {
        "alt_text": "Row of modern townhomes with attached garages",
        "public_id": "019fae2a-580f-77cb-84b7-160a1913fc30",
        "storage_key": "property/6767906449167571/019fae2a-580f-77cb-84b7-160a1913fc30.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Community",
      "description": "Exterior view of a row of townhomes featuring attached garages and a clean, modern design.",
      "link": "false",
      "alt_text": "A row of houses with garages and driveways.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/The%20Forum%20-%20Danielson%20Exterior%20Row.jpg"
    },
    {
      "id": "ec_3c057e53e022c69454c44c0d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-5aa2-70fb-8211-37d636e6a387.webp",
      "image_media": {
        "alt_text": "Exterior view of a multifamily property with townhouses and apartment buildings.",
        "public_id": "019fae2a-5aa2-70fb-8211-37d636e6a387",
        "storage_key": "property/6767906449167571/019fae2a-5aa2-70fb-8211-37d636e6a387.webp",
        "width": 2048,
        "height": 1536
      },
      "title": "Community",
      "description": "Discover our beautiful multifamily property featuring a variety of townhome and apartment buildings, set in a scenic landscape with mature trees and a serene waterfront.",
      "link": "false",
      "alt_text": "Exterior view of a multifamily property with townhouses and apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/77-web-or-mls-11158%20Brookley%20Pl%20NE-S1511-039.jpg"
    },
    {
      "id": "ec_3fe9eba0b65373fd58c9d54b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-5c37-7239-b6b6-2e5395567f5f.webp",
      "image_media": {
        "alt_text": "Rear view of townhomes with fenced backyards and green space.",
        "public_id": "019fae2a-5c37-7239-b6b6-2e5395567f5f",
        "storage_key": "property/6767906449167571/019fae2a-5c37-7239-b6b6-2e5395567f5f.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy private outdoor space in these townhomes, featuring fenced backyards perfect for relaxation or entertaining. Ample green space surrounds the property.",
      "link": "false",
      "alt_text": "Rear view of townhomes with fenced backyards and green space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/71-web-or-mls-11158%20Brookley%20Pl%20NE-S1511-033.jpg"
    },
    {
      "id": "ec_08e62db9c34aa09b24b56cc9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-6e78-7115-a8e0-854358c13a01.webp",
      "image_media": {
        "alt_text": "Exterior of townhome with a two-car garage and driveway.",
        "public_id": "019fae2a-6e78-7115-a8e0-854358c13a01",
        "storage_key": "property/6767906449167571/019fae2a-6e78-7115-a8e0-854358c13a01.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "View of the exterior of a townhome featuring a two-car garage, driveway, and neatly manicured lawn.",
      "link": "false",
      "alt_text": "Exterior of townhome with a two-car garage and driveway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/37-web-or-mls-11159%20Brookley%20Pl%20NE-S1511-037.jpg"
    },
    {
      "id": "ec_cbecefff1e9be7d5a16b154e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-6f78-710c-8994-63a327b89eaf.webp",
      "image_media": {
        "alt_text": "Exterior of modern townhomes with light siding, private garages, and individual HVAC units under a blue sky.",
        "public_id": "019fae2a-6f78-710c-8994-63a327b89eaf",
        "storage_key": "property/6767906449167571/019fae2a-6f78-710c-8994-63a327b89eaf.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Experience modern living in our townhome-style apartments, complete with private garages for ultimate convenience. Enjoy stylish exteriors and the comfort of your own space.",
      "link": "false",
      "alt_text": "Exterior of modern townhomes with light siding, private garages, and individual HVAC units under a blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/38-web-or-mls-11159%20Brookley%20Pl%20NE-S1511-038.jpg"
    },
    {
      "id": "ec_500c3182055ed7537b3d4007",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-6f75-72f9-8a83-94b3591987fa.webp",
      "image_media": {
        "alt_text": "Aerial view of a multifamily property with townhomes and apartment buildings.",
        "public_id": "019fae2a-6f75-72f9-8a83-94b3591987fa",
        "storage_key": "property/6767906449167571/019fae2a-6f75-72f9-8a83-94b3591987fa.webp",
        "width": 2048,
        "height": 1536
      },
      "title": "Community",
      "description": "Explore this stunning multifamily property featuring modern townhomes and apartment buildings, set against a backdrop of trees and a bright sky. A perfect blend of comfort and style awaits.",
      "link": "false",
      "alt_text": "Aerial view of a multifamily property with townhomes and apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/79-web-or-mls-11158%20Brookley%20Pl%20NE-S1511-041.jpg"
    },
    {
      "id": "ec_fa1488d2dc8b1b72234a39a3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-76d8-701e-a4df-007a1e10b87c.webp",
      "image_media": {
        "alt_text": "Row of townhomes with a black metal fence in the foreground and a blue sky with clouds.",
        "public_id": "019fae2a-76d8-701e-a4df-007a1e10b87c",
        "storage_key": "property/6767906449167571/019fae2a-76d8-701e-a4df-007a1e10b87c.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Exterior view of townhomes featuring light gray siding, visible air conditioning units, and a black metal fence surrounding the property under a partly cloudy sky.",
      "link": "false",
      "alt_text": "A row of houses with a black fence in front.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/73-web-or-mls-11158%20Brookley%20Pl%20NE-S1511-035.jpg"
    },
    {
      "id": "ec_8ac57c890ab204e0d032abd7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-7670-76ed-b07d-2540fd90e974.webp",
      "image_media": {
        "alt_text": "Street view of townhouses with garages and driveways, a lamp post and green grass under a cloudy sky.",
        "public_id": "019fae2a-7670-76ed-b07d-2540fd90e974",
        "storage_key": "property/6767906449167571/019fae2a-7670-76ed-b07d-2540fd90e974.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Exterior view of a townhouse community showcasing charming architecture, private garages, and well-maintained landscaping.",
      "link": "false",
      "alt_text": "Street view of townhouses with garages and driveways, a lamp post and green grass under a cloudy sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/35-web-or-mls-11159%20Brookley%20Pl%20NE-S1511-035.jpg"
    },
    {
      "id": "ec_efdeedf512c651ae2d550c6d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-9a16-762f-a153-727eb531b611.webp",
      "image_media": {
        "alt_text": "Backyard patio with a white vinyl fence and a black metal fence beyond.",
        "public_id": "019fae2a-9a16-762f-a153-727eb531b611",
        "storage_key": "property/6767906449167571/019fae2a-9a16-762f-a153-727eb531b611.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy private outdoor living on your own patio, perfect for relaxing or entertaining.",
      "link": "false",
      "alt_text": "A house with a white fence and a black gate.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/74-web-or-mls-11158%20Brookley%20Pl%20NE-S1511-036.jpg"
    },
    {
      "id": "ec_908f06dc4e40f109d93eafec",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-a9ce-71cb-a8bf-ec84679824a6.webp",
      "image_media": {
        "alt_text": "Aerial view of a multifamily property with a roundabout and surrounding buildings.",
        "public_id": "019fae2a-a9ce-71cb-a8bf-ec84679824a6",
        "storage_key": "property/6767906449167571/019fae2a-a9ce-71cb-a8bf-ec84679824a6.webp",
        "width": 2048,
        "height": 1536
      },
      "title": "Community",
      "description": "Expansive aerial view showcasing the community layout, featuring a central roundabout, apartment buildings, and townhomes.",
      "link": "false",
      "alt_text": "Aerial view of a multifamily property with a roundabout and surrounding buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/76-web-or-mls-11158%20Brookley%20Pl%20NE-S1511-038.jpg"
    },
    {
      "id": "ec_16d7085ca971ea2168f5a9d1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-acf8-72ce-b8d8-6ced93de6347.webp",
      "image_media": {
        "alt_text": "Aerial view of townhome community with multiple buildings and manicured landscaping.",
        "public_id": "019fae2a-acf8-72ce-b8d8-6ced93de6347",
        "storage_key": "property/6767906449167571/019fae2a-acf8-72ce-b8d8-6ced93de6347.webp",
        "width": 2048,
        "height": 1536
      },
      "title": "Community",
      "description": "Discover our beautiful townhome community, featuring modern architecture, lush greenery, and a serene atmosphere. Explore the exterior of our well-maintained buildings and courtyards.",
      "link": "false",
      "alt_text": "Aerial view of townhome community with multiple buildings and manicured landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/78-web-or-mls-11158%20Brookley%20Pl%20NE-S1511-040.jpg"
    },
    {
      "id": "ec_904be47fdca070048c507a5d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-b907-7265-af9f-297bf88e9f2b.webp",
      "image_media": {
        "alt_text": "Exterior of townhome-style apartments with attached garages and light gray siding.",
        "public_id": "019fae2a-b907-7265-af9f-297bf88e9f2b",
        "storage_key": "property/6767906449167571/019fae2a-b907-7265-af9f-297bf88e9f2b.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "View of the exterior of townhome-style apartment buildings. Features attached garages, light gray siding, and manicured lawns.",
      "link": "false",
      "alt_text": "Exterior of townhome-style apartments with attached garages and light gray siding.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/36-web-or-mls-11159%20Brookley%20Pl%20NE-S1511-036.jpg"
    },
    {
      "id": "ec_c22cca778b7271976dff1e20",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-c202-7418-9be0-da17f188f0f6.webp",
      "image_media": {
        "alt_text": "Aerial view of a multifamily property with apartment buildings and townhomes under a partly cloudy sky.",
        "public_id": "019fae2a-c202-7418-9be0-da17f188f0f6",
        "storage_key": "property/6767906449167571/019fae2a-c202-7418-9be0-da17f188f0f6.webp",
        "width": 2048,
        "height": 1536
      },
      "title": "Community",
      "description": "Expansive aerial view showcasing the modern architecture of the apartment buildings and townhomes within the community. Features multiple residential structures, paved roads, and landscaping under a bright, partly cloudy sky.",
      "link": "false",
      "alt_text": "Aerial view of a multifamily property with apartment buildings and townhomes under a partly cloudy sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/80-web-or-mls-11158%20Brookley%20Pl%20NE-S1511-042.jpg"
    },
    {
      "id": "ec_8d52274ff554fe087fc11b25",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-c876-771a-a67f-09d1baa3d448.webp",
      "image_media": {
        "alt_text": "Fenced backyard with patio, grass, and air conditioning unit, with apartment buildings in the background.",
        "public_id": "019fae2a-c876-771a-a67f-09d1baa3d448",
        "storage_key": "property/6767906449167571/019fae2a-c876-771a-a67f-09d1baa3d448.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy your private fenced backyard with a patio and plenty of green space. Perfect for relaxing or entertaining.",
      "link": "false",
      "alt_text": "Fenced backyard with patio, grass, and air conditioning unit, with apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/75-web-or-mls-11158%20Brookley%20Pl%20NE-S1511-037.jpg"
    },
    {
      "id": "ec_b156c2e832117121181c7893",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-ce32-7499-a431-5bb0657b6a67.webp",
      "image_media": {
        "alt_text": "Exterior view of townhomes with a fenced backyard and blue sky.",
        "public_id": "019fae2a-ce32-7499-a431-5bb0657b6a67",
        "storage_key": "property/6767906449167571/019fae2a-ce32-7499-a431-5bb0657b6a67.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Charming exterior view of townhomes featuring a private fenced backyard, perfect for relaxation and outdoor enjoyment.",
      "link": "false",
      "alt_text": "Exterior view of townhomes with a fenced backyard and blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/72-web-or-mls-11158%20Brookley%20Pl%20NE-S1511-034.jpg"
    },
    {
      "id": "ec_5654d462c0339a7825ea76cf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-d0a5-7587-bc6e-6af1ec2a675e.webp",
      "image_media": {
        "alt_text": "Bathroom with double vanity, granite countertops, and a toilet.",
        "public_id": "019fae2a-d0a5-7587-bc6e-6af1ec2a675e",
        "storage_key": "property/6767906449167571/019fae2a-d0a5-7587-bc6e-6af1ec2a675e.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a double vanity with granite countertops, modern fixtures, and a separate toilet area.",
      "link": "false",
      "alt_text": "Bathroom with double vanity, granite countertops, and a toilet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/25-web-or-mls-11159%20Brookley%20Pl%20NE-S1511-025.jpg"
    },
    {
      "id": "ec_52af71d337b390fce272927d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-d6e4-75fe-ae4a-e9caeeb65a99.webp",
      "image_media": {
        "alt_text": "Modern kitchen with gray cabinets, granite countertops, stainless steel appliances, and an island with a sink.",
        "public_id": "019fae2a-d6e4-75fe-ae4a-e9caeeb65a99",
        "storage_key": "property/6767906449167571/019fae2a-d6e4-75fe-ae4a-e9caeeb65a99.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring sleek gray cabinetry, durable granite countertops, and high-quality stainless steel appliances. The large island with a sink provides ample prep space and a convenient focal point.",
      "link": "false",
      "alt_text": "A modern kitchen with granite countertops and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/19-web-or-mls-11159%20Brookley%20Pl%20NE-S1511-019.jpg"
    },
    {
      "id": "ec_30fc8c4ce7edee13c9fc9f6f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-df8e-719a-bb3b-cfa982db3ddf.webp",
      "image_media": {
        "alt_text": "Modern kitchen and living area with wood-look flooring and stainless steel appliances.",
        "public_id": "019fae2a-df8e-719a-bb3b-cfa982db3ddf",
        "storage_key": "property/6767906449167571/019fae2a-df8e-719a-bb3b-cfa982db3ddf.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Open-concept living space featuring a sleek kitchen with a large island and ample cabinet storage, perfect for modern living.",
      "link": "false",
      "alt_text": "Modern kitchen and living area with wood-look flooring and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/7-web-or-mls-11159%20Brookley%20Pl%20NE-S1511-007.jpg"
    },
    {
      "id": "ec_f295f033011c129528c49c4c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-e499-719e-b83a-02741f77ee38.webp",
      "image_media": {
        "alt_text": "Row of townhomes with a black metal fence in front.",
        "public_id": "019fae2a-e499-719e-b83a-02741f77ee38",
        "storage_key": "property/6767906449167571/019fae2a-e499-719e-b83a-02741f77ee38.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Beautiful townhomes with light beige siding and white trim, lined up in a row with a black metal fence in the foreground.",
      "link": "false",
      "alt_text": "Row of townhomes with a black metal fence in front.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/3-web-or-mls-11159%20Brookley%20Pl%20NE-S1511-003.jpg"
    },
    {
      "id": "ec_0ebed40b29bbb3c087c5bde0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-e4fa-763c-a557-2262aa3b7070.webp",
      "image_media": {
        "alt_text": "Exterior view of townhome buildings with a black metal fence in front.",
        "public_id": "019fae2a-e4fa-763c-a557-2262aa3b7070",
        "storage_key": "property/6767906449167571/019fae2a-e4fa-763c-a557-2262aa3b7070.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Showcasing the charming exteriors of our townhome-style apartments, complete with private fenced yards.",
      "link": "false",
      "alt_text": "Exterior view of townhome buildings with a black metal fence in front.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/2-web-or-mls-11159%20Brookley%20Pl%20NE-S1511-002.jpg"
    },
    {
      "id": "ec_7f497c94054a4946f152a735",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-e6ec-718a-ac91-1ec0fe6764de.webp",
      "image_media": {
        "alt_text": "Double vanity bathroom with granite countertops and a glass-enclosed shower.",
        "public_id": "019fae2a-e6ec-718a-ac91-1ec0fe6764de",
        "storage_key": "property/6767906449167571/019fae2a-e6ec-718a-ac91-1ec0fe6764de.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a double vanity with granite countertops, ample cabinet storage, and a walk-in shower, perfect for relaxation and rejuvenation.",
      "link": "false",
      "alt_text": "Double vanity bathroom with granite countertops and a glass-enclosed shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/32-web-or-mls-11159%20Brookley%20Pl%20NE-S1511-032.jpg"
    },
    {
      "id": "ec_5ec6f60821e41e80f20cd7ee",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-eebf-723d-b3f3-8b06aad94f33.webp",
      "image_media": {
        "alt_text": "Interior of an unfinished garage with a large garage door, a pedestrian door, and 'Now Leasing' signs.",
        "public_id": "019fae2a-eebf-723d-b3f3-8b06aad94f33",
        "storage_key": "property/6767906449167571/019fae2a-eebf-723d-b3f3-8b06aad94f33.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Spacious garage area, ready for your vehicle. Features a large overhead door and a convenient pedestrian exit. 'Now Leasing' signs indicate availability.",
      "link": "false",
      "alt_text": "Interior of an unfinished garage with a large garage door, a pedestrian door, and 'Now Leasing' signs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/34-web-or-mls-11159%20Brookley%20Pl%20NE-S1511-034.jpg"
    },
    {
      "id": "ec_9f6194c342f113b907cd3069",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-f97b-70a8-ac0f-b195c5fed77e.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and ample cabinet space.",
        "public_id": "019fae2a-f97b-70a8-ac0f-b195c5fed77e",
        "storage_key": "property/6767906449167571/019fae2a-f97b-70a8-ac0f-b195c5fed77e.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious and elegant kitchen featuring a large island with a sink, sleek cabinetry, and a full suite of stainless steel appliances, perfect for culinary enthusiasts.",
      "link": "false",
      "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and ample cabinet space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/17-web-or-mls-11159%20Brookley%20Pl%20NE-S1511-017.jpg"
    },
    {
      "id": "ec_ef48561c1c74c32e32690cd8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-5aa2-70fb-8211-37d636e6a387.webp",
      "image_media": {
        "alt_text": "Exterior view of a multifamily property with townhouses and apartment buildings.",
        "public_id": "019fae2a-5aa2-70fb-8211-37d636e6a387",
        "storage_key": "property/6767906449167571/019fae2a-5aa2-70fb-8211-37d636e6a387.webp",
        "width": 2048,
        "height": 1536
      },
      "title": "Community",
      "description": "Discover our beautiful multifamily property featuring a variety of townhome and apartment buildings, set in a scenic landscape with mature trees and a serene waterfront.",
      "link": "false",
      "alt_text": "Exterior view of a multifamily property with townhouses and apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/77-web-or-mls-11158%20Brookley%20Pl%20NE-S1511-039.jpg"
    },
    {
      "id": "ec_3294945ae8574994d9530174",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2b-055a-72e0-8815-60ecaf8e1745.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a double vanity and a glass-enclosed shower.",
        "public_id": "019fae2b-055a-72e0-8815-60ecaf8e1745",
        "storage_key": "property/6767906449167571/019fae2b-055a-72e0-8815-60ecaf8e1745.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed bathroom, featuring a sleek double vanity with granite countertops and a spacious, glass-enclosed shower with modern fixtures. The perfect blend of style and functionality.",
      "link": "false",
      "alt_text": "A bathroom with a walk-in shower and a marble countertop.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/33-web-or-mls-11159%20Brookley%20Pl%20NE-S1511-033.jpg"
    },
    {
      "id": "ec_ded4b53ad7c135fecae95665",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-5c37-7239-b6b6-2e5395567f5f.webp",
      "image_media": {
        "alt_text": "Rear view of townhomes with fenced backyards and green space.",
        "public_id": "019fae2a-5c37-7239-b6b6-2e5395567f5f",
        "storage_key": "property/6767906449167571/019fae2a-5c37-7239-b6b6-2e5395567f5f.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy private outdoor space in these townhomes, featuring fenced backyards perfect for relaxation or entertaining. Ample green space surrounds the property.",
      "link": "false",
      "alt_text": "Rear view of townhomes with fenced backyards and green space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/71-web-or-mls-11158%20Brookley%20Pl%20NE-S1511-033.jpg"
    },
    {
      "id": "ec_0f4b6823fcbedc0bfd1bf5b0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2b-0a46-72d8-90af-b1080e0b876c.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with white wire shelving and wood-look flooring.",
        "public_id": "019fae2b-0a46-72d8-90af-b1080e0b876c",
        "storage_key": "property/6767906449167571/019fae2b-0a46-72d8-90af-b1080e0b876c.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring ample white wire shelving for organized storage. The closet has modern wood-look flooring and clean, neutral walls.",
      "link": "false",
      "alt_text": "Empty walk-in closet with white wire shelving and wood-look flooring.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/31-web-or-mls-11159%20Brookley%20Pl%20NE-S1511-031.jpg"
    },
    {
      "id": "ec_f7eeba3df81e121d860f238a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-6e78-7115-a8e0-854358c13a01.webp",
      "image_media": {
        "alt_text": "Exterior of townhome with a two-car garage and driveway.",
        "public_id": "019fae2a-6e78-7115-a8e0-854358c13a01",
        "storage_key": "property/6767906449167571/019fae2a-6e78-7115-a8e0-854358c13a01.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "View of the exterior of a townhome featuring a two-car garage, driveway, and neatly manicured lawn.",
      "link": "false",
      "alt_text": "Exterior of townhome with a two-car garage and driveway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/37-web-or-mls-11159%20Brookley%20Pl%20NE-S1511-037.jpg"
    },
    {
      "id": "ec_e687cafc47a15b7e31f822bb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2b-19b8-740b-a677-e8b1be9014d6.webp",
      "image_media": {
        "alt_text": "Spacious bedroom with tray ceiling, ceiling fan, and wood-look flooring.",
        "public_id": "019fae2b-19b8-740b-a677-e8b1be9014d6",
        "storage_key": "property/6767906449167571/019fae2b-19b8-740b-a677-e8b1be9014d6.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy comfort and style in this spacious bedroom, featuring a tray ceiling, modern ceiling fan, and beautiful wood-look flooring. A large window lets in plenty of natural light.",
      "link": "false",
      "alt_text": "Spacious bedroom with tray ceiling, ceiling fan, and wood-look flooring.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/29-web-or-mls-11159%20Brookley%20Pl%20NE-S1511-029.jpg"
    },
    {
      "id": "ec_506d69c34155b66eeb7518b4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-6f78-710c-8994-63a327b89eaf.webp",
      "image_media": {
        "alt_text": "Exterior of modern townhomes with light siding, private garages, and individual HVAC units under a blue sky.",
        "public_id": "019fae2a-6f78-710c-8994-63a327b89eaf",
        "storage_key": "property/6767906449167571/019fae2a-6f78-710c-8994-63a327b89eaf.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Experience modern living in our townhome-style apartments, complete with private garages for ultimate convenience. Enjoy stylish exteriors and the comfort of your own space.",
      "link": "false",
      "alt_text": "Exterior of modern townhomes with light siding, private garages, and individual HVAC units under a blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/38-web-or-mls-11159%20Brookley%20Pl%20NE-S1511-038.jpg"
    },
    {
      "id": "ec_02f40c3527811be1d202bebc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-6f75-72f9-8a83-94b3591987fa.webp",
      "image_media": {
        "alt_text": "Aerial view of a multifamily property with townhomes and apartment buildings.",
        "public_id": "019fae2a-6f75-72f9-8a83-94b3591987fa",
        "storage_key": "property/6767906449167571/019fae2a-6f75-72f9-8a83-94b3591987fa.webp",
        "width": 2048,
        "height": 1536
      },
      "title": "Community",
      "description": "Explore this stunning multifamily property featuring modern townhomes and apartment buildings, set against a backdrop of trees and a bright sky. A perfect blend of comfort and style awaits.",
      "link": "false",
      "alt_text": "Aerial view of a multifamily property with townhomes and apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/79-web-or-mls-11158%20Brookley%20Pl%20NE-S1511-041.jpg"
    },
    {
      "id": "ec_058edc711b8a34d5bc0cf26e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-76d8-701e-a4df-007a1e10b87c.webp",
      "image_media": {
        "alt_text": "Row of townhomes with a black metal fence in the foreground and a blue sky with clouds.",
        "public_id": "019fae2a-76d8-701e-a4df-007a1e10b87c",
        "storage_key": "property/6767906449167571/019fae2a-76d8-701e-a4df-007a1e10b87c.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Exterior view of townhomes featuring light gray siding, visible air conditioning units, and a black metal fence surrounding the property under a partly cloudy sky.",
      "link": "false",
      "alt_text": "A row of houses with a black fence in front.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/73-web-or-mls-11158%20Brookley%20Pl%20NE-S1511-035.jpg"
    },
    {
      "id": "ec_ed6cd7ec12ab883a55cbac73",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-7670-76ed-b07d-2540fd90e974.webp",
      "image_media": {
        "alt_text": "Street view of townhouses with garages and driveways, a lamp post and green grass under a cloudy sky.",
        "public_id": "019fae2a-7670-76ed-b07d-2540fd90e974",
        "storage_key": "property/6767906449167571/019fae2a-7670-76ed-b07d-2540fd90e974.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Exterior view of a townhouse community showcasing charming architecture, private garages, and well-maintained landscaping.",
      "link": "false",
      "alt_text": "Street view of townhouses with garages and driveways, a lamp post and green grass under a cloudy sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/35-web-or-mls-11159%20Brookley%20Pl%20NE-S1511-035.jpg"
    },
    {
      "id": "ec_d55d61d2b70c1ac89c8b0748",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-9a16-762f-a153-727eb531b611.webp",
      "image_media": {
        "alt_text": "Backyard patio with a white vinyl fence and a black metal fence beyond.",
        "public_id": "019fae2a-9a16-762f-a153-727eb531b611",
        "storage_key": "property/6767906449167571/019fae2a-9a16-762f-a153-727eb531b611.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy private outdoor living on your own patio, perfect for relaxing or entertaining.",
      "link": "false",
      "alt_text": "A house with a white fence and a black gate.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/74-web-or-mls-11158%20Brookley%20Pl%20NE-S1511-036.jpg"
    },
    {
      "id": "ec_e947f6aee3d8e636bb5fec6f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-a9ce-71cb-a8bf-ec84679824a6.webp",
      "image_media": {
        "alt_text": "Aerial view of a multifamily property with a roundabout and surrounding buildings.",
        "public_id": "019fae2a-a9ce-71cb-a8bf-ec84679824a6",
        "storage_key": "property/6767906449167571/019fae2a-a9ce-71cb-a8bf-ec84679824a6.webp",
        "width": 2048,
        "height": 1536
      },
      "title": "Community",
      "description": "Expansive aerial view showcasing the community layout, featuring a central roundabout, apartment buildings, and townhomes.",
      "link": "false",
      "alt_text": "Aerial view of a multifamily property with a roundabout and surrounding buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/76-web-or-mls-11158%20Brookley%20Pl%20NE-S1511-038.jpg"
    },
    {
      "id": "ec_99204ac4d245d5d687500d96",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-acf8-72ce-b8d8-6ced93de6347.webp",
      "image_media": {
        "alt_text": "Aerial view of townhome community with multiple buildings and manicured landscaping.",
        "public_id": "019fae2a-acf8-72ce-b8d8-6ced93de6347",
        "storage_key": "property/6767906449167571/019fae2a-acf8-72ce-b8d8-6ced93de6347.webp",
        "width": 2048,
        "height": 1536
      },
      "title": "Community",
      "description": "Discover our beautiful townhome community, featuring modern architecture, lush greenery, and a serene atmosphere. Explore the exterior of our well-maintained buildings and courtyards.",
      "link": "false",
      "alt_text": "Aerial view of townhome community with multiple buildings and manicured landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/78-web-or-mls-11158%20Brookley%20Pl%20NE-S1511-040.jpg"
    },
    {
      "id": "ec_a2b742f2a98eeb4c3e2bf344",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-b907-7265-af9f-297bf88e9f2b.webp",
      "image_media": {
        "alt_text": "Exterior of townhome-style apartments with attached garages and light gray siding.",
        "public_id": "019fae2a-b907-7265-af9f-297bf88e9f2b",
        "storage_key": "property/6767906449167571/019fae2a-b907-7265-af9f-297bf88e9f2b.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "View of the exterior of townhome-style apartment buildings. Features attached garages, light gray siding, and manicured lawns.",
      "link": "false",
      "alt_text": "Exterior of townhome-style apartments with attached garages and light gray siding.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/36-web-or-mls-11159%20Brookley%20Pl%20NE-S1511-036.jpg"
    },
    {
      "id": "ec_4199e5f92c397ca1bd8dd07a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-c202-7418-9be0-da17f188f0f6.webp",
      "image_media": {
        "alt_text": "Aerial view of a multifamily property with apartment buildings and townhomes under a partly cloudy sky.",
        "public_id": "019fae2a-c202-7418-9be0-da17f188f0f6",
        "storage_key": "property/6767906449167571/019fae2a-c202-7418-9be0-da17f188f0f6.webp",
        "width": 2048,
        "height": 1536
      },
      "title": "Community",
      "description": "Expansive aerial view showcasing the modern architecture of the apartment buildings and townhomes within the community. Features multiple residential structures, paved roads, and landscaping under a bright, partly cloudy sky.",
      "link": "false",
      "alt_text": "Aerial view of a multifamily property with apartment buildings and townhomes under a partly cloudy sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/80-web-or-mls-11158%20Brookley%20Pl%20NE-S1511-042.jpg"
    },
    {
      "id": "ec_e36dbf0e10e167e0067ee9e0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-c876-771a-a67f-09d1baa3d448.webp",
      "image_media": {
        "alt_text": "Fenced backyard with patio, grass, and air conditioning unit, with apartment buildings in the background.",
        "public_id": "019fae2a-c876-771a-a67f-09d1baa3d448",
        "storage_key": "property/6767906449167571/019fae2a-c876-771a-a67f-09d1baa3d448.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy your private fenced backyard with a patio and plenty of green space. Perfect for relaxing or entertaining.",
      "link": "false",
      "alt_text": "Fenced backyard with patio, grass, and air conditioning unit, with apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/75-web-or-mls-11158%20Brookley%20Pl%20NE-S1511-037.jpg"
    },
    {
      "id": "ec_70c5d089cc4047ca3b759735",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-ce32-7499-a431-5bb0657b6a67.webp",
      "image_media": {
        "alt_text": "Exterior view of townhomes with a fenced backyard and blue sky.",
        "public_id": "019fae2a-ce32-7499-a431-5bb0657b6a67",
        "storage_key": "property/6767906449167571/019fae2a-ce32-7499-a431-5bb0657b6a67.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Charming exterior view of townhomes featuring a private fenced backyard, perfect for relaxation and outdoor enjoyment.",
      "link": "false",
      "alt_text": "Exterior view of townhomes with a fenced backyard and blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/72-web-or-mls-11158%20Brookley%20Pl%20NE-S1511-034.jpg"
    },
    {
      "id": "ec_0b5a7525a70d49ce7a7dfbb7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-d0a5-7587-bc6e-6af1ec2a675e.webp",
      "image_media": {
        "alt_text": "Bathroom with double vanity, granite countertops, and a toilet.",
        "public_id": "019fae2a-d0a5-7587-bc6e-6af1ec2a675e",
        "storage_key": "property/6767906449167571/019fae2a-d0a5-7587-bc6e-6af1ec2a675e.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a double vanity with granite countertops, modern fixtures, and a separate toilet area.",
      "link": "false",
      "alt_text": "Bathroom with double vanity, granite countertops, and a toilet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/25-web-or-mls-11159%20Brookley%20Pl%20NE-S1511-025.jpg"
    },
    {
      "id": "ec_693d737185a8ec8b27605baf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-d6e4-75fe-ae4a-e9caeeb65a99.webp",
      "image_media": {
        "alt_text": "Modern kitchen with gray cabinets, granite countertops, stainless steel appliances, and an island with a sink.",
        "public_id": "019fae2a-d6e4-75fe-ae4a-e9caeeb65a99",
        "storage_key": "property/6767906449167571/019fae2a-d6e4-75fe-ae4a-e9caeeb65a99.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring sleek gray cabinetry, durable granite countertops, and high-quality stainless steel appliances. The large island with a sink provides ample prep space and a convenient focal point.",
      "link": "false",
      "alt_text": "A modern kitchen with granite countertops and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/19-web-or-mls-11159%20Brookley%20Pl%20NE-S1511-019.jpg"
    },
    {
      "id": "ec_3230338ae9983beeeeb613be",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-df8e-719a-bb3b-cfa982db3ddf.webp",
      "image_media": {
        "alt_text": "Modern kitchen and living area with wood-look flooring and stainless steel appliances.",
        "public_id": "019fae2a-df8e-719a-bb3b-cfa982db3ddf",
        "storage_key": "property/6767906449167571/019fae2a-df8e-719a-bb3b-cfa982db3ddf.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Open-concept living space featuring a sleek kitchen with a large island and ample cabinet storage, perfect for modern living.",
      "link": "false",
      "alt_text": "Modern kitchen and living area with wood-look flooring and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/7-web-or-mls-11159%20Brookley%20Pl%20NE-S1511-007.jpg"
    },
    {
      "id": "ec_ef6b183c06f7a86cec5d5c0c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-e499-719e-b83a-02741f77ee38.webp",
      "image_media": {
        "alt_text": "Row of townhomes with a black metal fence in front.",
        "public_id": "019fae2a-e499-719e-b83a-02741f77ee38",
        "storage_key": "property/6767906449167571/019fae2a-e499-719e-b83a-02741f77ee38.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Beautiful townhomes with light beige siding and white trim, lined up in a row with a black metal fence in the foreground.",
      "link": "false",
      "alt_text": "Row of townhomes with a black metal fence in front.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/3-web-or-mls-11159%20Brookley%20Pl%20NE-S1511-003.jpg"
    },
    {
      "id": "ec_064b4a79a62146de8b3c512e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-e4fa-763c-a557-2262aa3b7070.webp",
      "image_media": {
        "alt_text": "Exterior view of townhome buildings with a black metal fence in front.",
        "public_id": "019fae2a-e4fa-763c-a557-2262aa3b7070",
        "storage_key": "property/6767906449167571/019fae2a-e4fa-763c-a557-2262aa3b7070.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Showcasing the charming exteriors of our townhome-style apartments, complete with private fenced yards.",
      "link": "false",
      "alt_text": "Exterior view of townhome buildings with a black metal fence in front.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/2-web-or-mls-11159%20Brookley%20Pl%20NE-S1511-002.jpg"
    },
    {
      "id": "ec_f2f723565d7fbc0f61e62e8d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-e6ec-718a-ac91-1ec0fe6764de.webp",
      "image_media": {
        "alt_text": "Double vanity bathroom with granite countertops and a glass-enclosed shower.",
        "public_id": "019fae2a-e6ec-718a-ac91-1ec0fe6764de",
        "storage_key": "property/6767906449167571/019fae2a-e6ec-718a-ac91-1ec0fe6764de.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a double vanity with granite countertops, ample cabinet storage, and a walk-in shower, perfect for relaxation and rejuvenation.",
      "link": "false",
      "alt_text": "Double vanity bathroom with granite countertops and a glass-enclosed shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/32-web-or-mls-11159%20Brookley%20Pl%20NE-S1511-032.jpg"
    },
    {
      "id": "ec_75c0c242e98c0fb4f9deb391",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-eebf-723d-b3f3-8b06aad94f33.webp",
      "image_media": {
        "alt_text": "Interior of an unfinished garage with a large garage door, a pedestrian door, and 'Now Leasing' signs.",
        "public_id": "019fae2a-eebf-723d-b3f3-8b06aad94f33",
        "storage_key": "property/6767906449167571/019fae2a-eebf-723d-b3f3-8b06aad94f33.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Spacious garage area, ready for your vehicle. Features a large overhead door and a convenient pedestrian exit. 'Now Leasing' signs indicate availability.",
      "link": "false",
      "alt_text": "Interior of an unfinished garage with a large garage door, a pedestrian door, and 'Now Leasing' signs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/34-web-or-mls-11159%20Brookley%20Pl%20NE-S1511-034.jpg"
    },
    {
      "id": "ec_3da3e4ca78cf19de13c964b4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-f97b-70a8-ac0f-b195c5fed77e.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and ample cabinet space.",
        "public_id": "019fae2a-f97b-70a8-ac0f-b195c5fed77e",
        "storage_key": "property/6767906449167571/019fae2a-f97b-70a8-ac0f-b195c5fed77e.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious and elegant kitchen featuring a large island with a sink, sleek cabinetry, and a full suite of stainless steel appliances, perfect for culinary enthusiasts.",
      "link": "false",
      "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and ample cabinet space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/17-web-or-mls-11159%20Brookley%20Pl%20NE-S1511-017.jpg"
    },
    {
      "id": "ec_4d86dad48eebdf8a1d431363",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2b-055a-72e0-8815-60ecaf8e1745.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a double vanity and a glass-enclosed shower.",
        "public_id": "019fae2b-055a-72e0-8815-60ecaf8e1745",
        "storage_key": "property/6767906449167571/019fae2b-055a-72e0-8815-60ecaf8e1745.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed bathroom, featuring a sleek double vanity with granite countertops and a spacious, glass-enclosed shower with modern fixtures. The perfect blend of style and functionality.",
      "link": "false",
      "alt_text": "A bathroom with a walk-in shower and a marble countertop.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/33-web-or-mls-11159%20Brookley%20Pl%20NE-S1511-033.jpg"
    },
    {
      "id": "ec_ddd6ed4c7294f830948bf9f5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2b-0a46-72d8-90af-b1080e0b876c.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with white wire shelving and wood-look flooring.",
        "public_id": "019fae2b-0a46-72d8-90af-b1080e0b876c",
        "storage_key": "property/6767906449167571/019fae2b-0a46-72d8-90af-b1080e0b876c.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring ample white wire shelving for organized storage. The closet has modern wood-look flooring and clean, neutral walls.",
      "link": "false",
      "alt_text": "Empty walk-in closet with white wire shelving and wood-look flooring.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/31-web-or-mls-11159%20Brookley%20Pl%20NE-S1511-031.jpg"
    },
    {
      "id": "ec_183588698433394c4a951cee",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2b-19b8-740b-a677-e8b1be9014d6.webp",
      "image_media": {
        "alt_text": "Spacious bedroom with tray ceiling, ceiling fan, and wood-look flooring.",
        "public_id": "019fae2b-19b8-740b-a677-e8b1be9014d6",
        "storage_key": "property/6767906449167571/019fae2b-19b8-740b-a677-e8b1be9014d6.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy comfort and style in this spacious bedroom, featuring a tray ceiling, modern ceiling fan, and beautiful wood-look flooring. A large window lets in plenty of natural light.",
      "link": "false",
      "alt_text": "Spacious bedroom with tray ceiling, ceiling fan, and wood-look flooring.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/29-web-or-mls-11159%20Brookley%20Pl%20NE-S1511-029.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_0aee3661-68bb-4772-9c28-cb87193271b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "poi_name": "Freddy's Frozen Custard & Steakburgers",
      "poi_type": "Restaurants",
      "poi_address": "12200 Town Center Dr, Covington, GA 30014, USA",
      "poi_short_description": "Vintage-style chain for steakburgers, hot dogs & other fast-food staples, plus frozen custard.",
      "poi_long_description": "Vintage-style chain for steakburgers, hot dogs & other fast-food staples, plus frozen custard.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bd-459b-7739-92b0-e0d215272700.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9bd-459b-7739-92b0-e0d215272700",
        "storage_key": "property/6767906449167571/019fa9bd-459b-7739-92b0-e0d215272700.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.freddys.com/location/covington?utm_source=gbp&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=16861035666329262118&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "freddys-frozen-custard--steakburgers",
      "poi_latitude": "33.6213581",
      "poi_longitude": "-83.83885529999999",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 470-205-1401",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-473a-75cc-bad9-c3b1c6f48fc6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9bb-473a-75cc-bad9-c3b1c6f48fc6",
        "storage_key": "property/6767906449167571/019fa9bb-473a-75cc-bad9-c3b1c6f48fc6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ88rXDLUz9IgRJli_3Jpu_uk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_fbfed523-89a1-443d-9ec0-99c7e64299a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "11500 Town Center Dr, Covington, GA 30014, USA",
      "poi_short_description": "Chain dishing up waffle-cut fries, biscuits and chicken dishes for breakfast, lunch and dinner.",
      "poi_long_description": "Chain dishing up waffle-cut fries, biscuits and chicken dishes for breakfast, lunch and dinner.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bd-4408-7001-bab9-4dadd4c8f19e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9bd-4408-7001-bab9-4dadd4c8f19e",
        "storage_key": "property/6767906449167571/019fa9bd-4408-7001-bab9-4dadd4c8f19e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ga/covington-town-center?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=11224391380262395243&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "33.620113",
      "poi_longitude": "-83.8403529",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 678-695-6577",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-473a-75cc-bad9-c3b1c6f48fc6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9bb-473a-75cc-bad9-c3b1c6f48fc6",
        "storage_key": "property/6767906449167571/019fa9bb-473a-75cc-bad9-c3b1c6f48fc6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJsfLlQXUz9IgRax1_sH0MxZs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_afda917f-8d07-44a0-9902-c988b40896dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "poi_name": "Panda Express",
      "poi_type": "Restaurants",
      "poi_address": "12856 Town Center Dr, Covington, GA 30014, USA",
      "poi_short_description": "Counter-service eatery specializing in familiar Chinese fare like fried rice, noodles and chow mein.",
      "poi_long_description": "Counter-service eatery specializing in familiar Chinese fare like fried rice, noodles and chow mein.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bd-4dc7-746c-b118-463b05e4e665.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9bd-4dc7-746c-b118-463b05e4e665",
        "storage_key": "property/6767906449167571/019fa9bd-4dc7-746c-b118-463b05e4e665.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.pandaexpress.com/locations/ga/covington/3536?utm_source=google_gbp&utm_medium=organic&utm_campaign=websitelink",
      "poi_directions_map_url": "https://maps.google.com/?cid=12380095932091441701&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "panda-express",
      "poi_latitude": "33.623019",
      "poi_longitude": "-83.83691499999999",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 678-831-0708",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-473a-75cc-bad9-c3b1c6f48fc6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9bb-473a-75cc-bad9-c3b1c6f48fc6",
        "storage_key": "property/6767906449167571/019fa9bb-473a-75cc-bad9-c3b1c6f48fc6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJd3beVHcz9IgRJaKRXajvzqs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_9c2d7aa1-4e35-4944-84ee-4e79a9e24102",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "poi_name": "Jim 'N Nick's Bar-B-Q",
      "poi_type": "Restaurants",
      "poi_address": "11300 Town Center Dr, Covington, GA 30014, USA",
      "poi_short_description": "Laid-back chain known for slow-cooked BBQ & cheese biscuits, plus burgers, salads & classic sides.",
      "poi_long_description": "Laid-back chain known for slow-cooked BBQ & cheese biscuits, plus burgers, salads & classic sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bd-494a-708e-9431-eaf0235a3800.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9bd-494a-708e-9431-eaf0235a3800",
        "storage_key": "property/6767906449167571/019fa9bd-494a-708e-9431-eaf0235a3800.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.jimnnicks.com/locations/ga/covington/11300-town-center-drive",
      "poi_directions_map_url": "https://maps.google.com/?cid=10476540844090277583&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jim-n-nicks-bar-b-q",
      "poi_latitude": "33.6195146",
      "poi_longitude": "-83.84094739999999",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 678-661-9981",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-473a-75cc-bad9-c3b1c6f48fc6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9bb-473a-75cc-bad9-c3b1c6f48fc6",
        "storage_key": "property/6767906449167571/019fa9bb-473a-75cc-bad9-c3b1c6f48fc6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJF-8u9hoz9IgRzz7f_mMmZJE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_09fc3ce9-e6fb-4ff5-b4e1-c39a7653419f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "poi_name": "Whataburger",
      "poi_type": "Restaurants",
      "poi_address": "11200 Town Center Dr, Covington, GA 30014, USA",
      "poi_short_description": "Circa-1950 fast-food chain for counter-serve burgers, some stacked with multiple patties.",
      "poi_long_description": "Circa-1950 fast-food chain for counter-serve burgers, some stacked with multiple patties.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-14c5-756c-945f-0b03791110e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9bb-14c5-756c-945f-0b03791110e1",
        "storage_key": "property/6767906449167571/019fa9bb-14c5-756c-945f-0b03791110e1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.whataburger.com/ga/covington/11200-town-center-dr.html/?utm_source=yextpages&utm_medium=locallistings&utm_campaign=yextpages",
      "poi_directions_map_url": "https://maps.google.com/?cid=11738441328367558676&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whataburger",
      "poi_latitude": "33.6190237",
      "poi_longitude": "-83.8415458",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 678-712-4156",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-473a-75cc-bad9-c3b1c6f48fc6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9bb-473a-75cc-bad9-c3b1c6f48fc6",
        "storage_key": "property/6767906449167571/019fa9bb-473a-75cc-bad9-c3b1c6f48fc6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJxeV6Em8z9IgRFOAc-jFS56I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_c9d7a41c-0741-4dda-9319-906cb80d8ca8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "poi_name": "Tubby Tom's Sports Bar & Grill",
      "poi_type": "Restaurants",
      "poi_address": "9148 US-278, Covington, GA 30014, USA",
      "poi_short_description": "Relaxed corner eatery serving classic American dishes, sandwiches, wings and beer.",
      "poi_long_description": "Relaxed corner eatery serving classic American dishes, sandwiches, wings and beer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bd-4997-71eb-910b-7e7507b35d7c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9bd-4997-71eb-910b-7e7507b35d7c",
        "storage_key": "property/6767906449167571/019fa9bd-4997-71eb-910b-7e7507b35d7c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tubbytomsbarandgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6099293288210042634&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tubby-toms-sports-bar--grill",
      "poi_latitude": "33.5984785",
      "poi_longitude": "-83.8325346",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 678-712-6166",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-473a-75cc-bad9-c3b1c6f48fc6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9bb-473a-75cc-bad9-c3b1c6f48fc6",
        "storage_key": "property/6767906449167571/019fa9bb-473a-75cc-bad9-c3b1c6f48fc6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJVcXwGXYz9IgRCg-vIO4KpVQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_9a4a9516-afe4-4d51-876d-58f9e0463a5d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "poi_name": "Kobe Hibachi & Sushi",
      "poi_type": "Restaurants",
      "poi_address": "3161 Elm St NE, Covington, GA 30014, USA",
      "poi_short_description": "Laid-back eatery in a shopping center serving Japanese staples such as hibachi items and sushi rolls.",
      "poi_long_description": "Laid-back eatery in a shopping center serving Japanese staples such as hibachi items and sushi rolls.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bd-44db-766b-8b3b-fdef1754993d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9bd-44db-766b-8b3b-fdef1754993d",
        "storage_key": "property/6767906449167571/019fa9bd-44db-766b-8b3b-fdef1754993d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.orderkobehibachisushi.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16090281242697183746&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kobe-hibachi--sushi",
      "poi_latitude": "33.6038707",
      "poi_longitude": "-83.85664969999999",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 678-712-6933",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-473a-75cc-bad9-c3b1c6f48fc6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9bb-473a-75cc-bad9-c3b1c6f48fc6",
        "storage_key": "property/6767906449167571/019fa9bb-473a-75cc-bad9-c3b1c6f48fc6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW-J-Uto19IgRArIYT4opTN8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_d97c986d-4e81-4525-a908-0602ae23944a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "poi_name": "Mystic Grill",
      "poi_type": "Restaurants",
      "poi_address": "1116 Clark St SW, Covington, GA 30014, USA",
      "poi_short_description": "Creative Southern cuisine served in a stylish, vintage-chic setting with rooftop seating.",
      "poi_long_description": "Creative Southern cuisine served in a stylish, vintage-chic setting with rooftop seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-1515-70ed-9595-ad8f18d7a493.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9bb-1515-70ed-9595-ad8f18d7a493",
        "storage_key": "property/6767906449167571/019fa9bb-1515-70ed-9595-ad8f18d7a493.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://mysticgrill.restaurant/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13040928396670937534&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mystic-grill",
      "poi_latitude": "33.5970837",
      "poi_longitude": "-83.8598481",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 770-728-1670",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-473a-75cc-bad9-c3b1c6f48fc6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9bb-473a-75cc-bad9-c3b1c6f48fc6",
        "storage_key": "property/6767906449167571/019fa9bb-473a-75cc-bad9-c3b1c6f48fc6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ_g4_WI09IgRvingcEiv-rQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_dddb6c21-cf96-470a-a091-3391fa9194a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "poi_name": "City Pharmacy",
      "poi_type": "Restaurants",
      "poi_address": "1105 Church St, Covington, GA 30014, USA",
      "poi_short_description": "Seasonal New American spot serving Southern-influenced dishes & smart cocktails in historic digs.",
      "poi_long_description": "Seasonal New American spot serving Southern-influenced dishes & smart cocktails in historic digs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bd-4d13-703b-b2e5-b8ae06141813.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9bd-4d13-703b-b2e5-b8ae06141813",
        "storage_key": "property/6767906449167571/019fa9bd-4d13-703b-b2e5-b8ae06141813.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "http://citypharmacycov.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5219793085749616082&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "city-pharmacy",
      "poi_latitude": "33.5967085",
      "poi_longitude": "-83.8592062",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 470-441-5092",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-473a-75cc-bad9-c3b1c6f48fc6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9bb-473a-75cc-bad9-c3b1c6f48fc6",
        "storage_key": "property/6767906449167571/019fa9bb-473a-75cc-bad9-c3b1c6f48fc6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ20YvIGM09IgR0l0l5SducEg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_685ef312-12b2-4e29-9163-34693782bbd8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "poi_name": "Town House Cafe",
      "poi_type": "Restaurants",
      "poi_address": "1145 Washington St SW, Covington, GA 30014, USA",
      "poi_short_description": "Fried green tomatoes and pork chops feature at this casual breakfast, brunch, and lunch eatery since the 1960’s.",
      "poi_long_description": "Fried green tomatoes and pork chops feature at this casual breakfast, brunch, and lunch eatery since the 1960’s.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bd-4612-74d0-92f2-6fe718469312.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9bd-4612-74d0-92f2-6fe718469312",
        "storage_key": "property/6767906449167571/019fa9bd-4612-74d0-92f2-6fe718469312.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.thetownhousecafe.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11601300976859994359&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "town-house-cafe",
      "poi_latitude": "33.5959626",
      "poi_longitude": "-83.8608812",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 770-787-2788",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-473a-75cc-bad9-c3b1c6f48fc6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9bb-473a-75cc-bad9-c3b1c6f48fc6",
        "storage_key": "property/6767906449167571/019fa9bb-473a-75cc-bad9-c3b1c6f48fc6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ3WhpmM09IgR99ghqsUZAKE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_2ae55c79-a803-488b-9d4b-b9d4f03c20aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "poi_name": "El Charro Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "Covington Corners Shopping Center, 3165 Elm St NE, Covington, GA 30014, USA",
      "poi_short_description": "Local cantina chain serving traditional Mexican food & margaritas in a warm, relaxed space.",
      "poi_long_description": "Local cantina chain serving traditional Mexican food & margaritas in a warm, relaxed space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bd-46be-720a-9753-c68566fc01f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9bd-46be-720a-9753-c68566fc01f1",
        "storage_key": "property/6767906449167571/019fa9bd-46be-720a-9753-c68566fc01f1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15075868372463415247&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-charro-mexican-restaurant",
      "poi_latitude": "33.6040452",
      "poi_longitude": "-83.8566524",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 770-786-2483",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-473a-75cc-bad9-c3b1c6f48fc6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9bb-473a-75cc-bad9-c3b1c6f48fc6",
        "storage_key": "property/6767906449167571/019fa9bb-473a-75cc-bad9-c3b1c6f48fc6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJz5OAgIY09IgRz286zWg-ONE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_d1aca1d5-8463-4c8b-920a-f77ab7bffdf8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "poi_name": "LongHorn Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "6112 Pavilion Way, Covington, GA 30014, USA",
      "poi_short_description": "Casual steakhouse chain known for grilled beef & other American dishes in a ranch-style space.",
      "poi_long_description": "Casual steakhouse chain known for grilled beef & other American dishes in a ranch-style space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-10c2-7169-a1df-cc8c3b73fb7b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9bb-10c2-7169-a1df-cc8c3b73fb7b",
        "storage_key": "property/6767906449167571/019fa9bb-10c2-7169-a1df-cc8c3b73fb7b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.longhornsteakhouse.com/locations/ga/covington/covington/5244?cmpid=br:lh_ag:ie_ch:loc_ca:LHGMB_sn:gmb_gt:covington-ga-5244_pl:locurl_rd:1196",
      "poi_directions_map_url": "https://maps.google.com/?cid=8122017511437338815&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "longhorn-steakhouse",
      "poi_latitude": "33.605857",
      "poi_longitude": "-83.87254899999999",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 678-625-4320",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-473a-75cc-bad9-c3b1c6f48fc6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9bb-473a-75cc-bad9-c3b1c6f48fc6",
        "storage_key": "property/6767906449167571/019fa9bb-473a-75cc-bad9-c3b1c6f48fc6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJEVM7AmM09IgRv4i59OQzt3A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_a959bd51-7b3d-45d2-b590-7b524b137243",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "poi_name": "Olive Garden Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "6138 Pavillion Way, Covington, GA 30014, USA",
      "poi_short_description": "Lively, family-friendly chain featuring Italian standards such as pastas & salads.",
      "poi_long_description": "Lively, family-friendly chain featuring Italian standards such as pastas & salads.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-1005-754c-87d6-7d0ac1db7561.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9bb-1005-754c-87d6-7d0ac1db7561",
        "storage_key": "property/6767906449167571/019fa9bb-1005-754c-87d6-7d0ac1db7561.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.olivegarden.com/locations/ga/covington/covington-ga-near-covington-crossings/6509?cmpid=br:og_ag:ie_ch:loc_ca:OGGMB_sn:gmb_gt:covington-ga-6509_pl:locurl_rd:1931",
      "poi_directions_map_url": "https://maps.google.com/?cid=2982032219875720032&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "olive-garden-italian-restaurant",
      "poi_latitude": "33.606377",
      "poi_longitude": "-83.8732873",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 470-441-3259",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-473a-75cc-bad9-c3b1c6f48fc6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9bb-473a-75cc-bad9-c3b1c6f48fc6",
        "storage_key": "property/6767906449167571/019fa9bb-473a-75cc-bad9-c3b1c6f48fc6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJN_e3OjU19IgRYDt2JoFOYik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_ee4b9be6-eadb-4779-8c5e-1d958e30a179",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "poi_name": "Publix Super Market at Covington Town Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "12701 Town Center Dr, Covington, GA 30014, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-0ff6-74c2-8c0b-7f1baa782e8c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9bb-0ff6-74c2-8c0b-7f1baa782e8c",
        "storage_key": "property/6767906449167571/019fa9bb-0ff6-74c2-8c0b-7f1baa782e8c.webp",
        "width": 1128,
        "height": 846
      },
      "poi_business_url": "https://www.publix.com/?utm_medium=maps&utm_source=google&utm_content=psm_google_override",
      "poi_directions_map_url": "https://maps.google.com/?cid=10692552167580276216&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-at-covington-town-center",
      "poi_latitude": "33.6239704",
      "poi_longitude": "-83.8391935",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 770-385-5705",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-4718-7297-8e71-87e7bc27bdca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9bb-4718-7297-8e71-87e7bc27bdca",
        "storage_key": "property/6767906449167571/019fa9bb-4718-7297-8e71-87e7bc27bdca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJye7BB9Qz9IgR-JX0eouTY5Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_9212c996-36fe-4182-9809-31cd5840560b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "3139 Hwy 278 NE, Covington, GA 30014, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bd-5110-75a9-b23e-036359231f3a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9bd-5110-75a9-b23e-036359231f3a",
        "storage_key": "property/6767906449167571/019fa9bd-5110-75a9-b23e-036359231f3a.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/ga/covington/newton-plaza/011/00214?cid=loc_01100214_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=7110690280922559020&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "33.6044703",
      "poi_longitude": "-83.85889569999999",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 770-787-0724",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-4718-7297-8e71-87e7bc27bdca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9bb-4718-7297-8e71-87e7bc27bdca",
        "storage_key": "property/6767906449167571/019fa9bb-4718-7297-8e71-87e7bc27bdca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJizlpkIg09IgRLDI27iI_rmI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_bb7b7b06-0c19-4451-908b-7030a169d59b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "11152 GA-142, Covington, GA 30014, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-15eb-7681-b9b4-8b98245e125f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9bb-15eb-7681-b9b4-8b98245e125f",
        "storage_key": "property/6767906449167571/019fa9bb-15eb-7681-b9b4-8b98245e125f.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://info.aldi.us/stores/l/ga/covington/11152-highway-142-ne/l924",
      "poi_directions_map_url": "https://maps.google.com/?cid=3267581049707766061&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "33.607759",
      "poi_longitude": "-83.826698",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-4718-7297-8e71-87e7bc27bdca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9bb-4718-7297-8e71-87e7bc27bdca",
        "storage_key": "property/6767906449167571/019fa9bb-4718-7297-8e71-87e7bc27bdca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW1CgbxMz9IgRLSGh_qbHWC0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_1a6fe8df-694c-4b9a-828c-74ede9a5d6bf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "10300 Industrial Blvd, Covington, GA 30014, USA",
      "poi_short_description": "Chain retailer with a wide selection of products, including clothing, furniture, electronics, and groceries.",
      "poi_long_description": "Chain retailer with a wide selection of products, including clothing, furniture, electronics, and groceries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bd-52c7-74fe-8ac2-9e596519b379.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9bd-52c7-74fe-8ac2-9e596519b379",
        "storage_key": "property/6767906449167571/019fa9bd-52c7-74fe-8ac2-9e596519b379.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/459-covington-ga/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=18398677101682366199&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "33.6107332",
      "poi_longitude": "-83.8301941",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 770-787-8030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-470b-764c-95a5-ac75cb8fb035.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9bb-470b-764c-95a5-ac75cb8fb035",
        "storage_key": "property/6767906449167571/019fa9bb-470b-764c-95a5-ac75cb8fb035.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ51HHvm0z9IgR9xbk9lc7Vf8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_2d4f674f-096e-41cb-82ba-3a62d80d7c4b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "poi_name": "QuikTrip",
      "poi_type": "Transportation & Transit",
      "poi_address": "10900 Town Center Dr, Covington, GA 30014, USA",
      "poi_short_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_long_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bd-517b-75f2-a898-6ddcdc44c7a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9bd-517b-75f2-a898-6ddcdc44c7a3",
        "storage_key": "property/6767906449167571/019fa9bd-517b-75f2-a898-6ddcdc44c7a3.webp",
        "width": 600,
        "height": 339
      },
      "poi_business_url": "https://locations.quiktrip.com/ga/covington/10900-town-center-dr?utm_source=gmb&utm_medium=yext&y_source=1_MTAyNjE3NDI3NC03MTUtbG9jYXRpb24ud2Vic2l0ZQ==",
      "poi_directions_map_url": "https://maps.google.com/?cid=12258462929844600355&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "quiktrip",
      "poi_latitude": "33.6184746",
      "poi_longitude": "-83.842199",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 678-660-7256",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bd-7fc8-7572-a45e-cb34bf0cadb4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9bd-7fc8-7572-a45e-cb34bf0cadb4",
        "storage_key": "property/6767906449167571/019fa9bd-7fc8-7572-a45e-cb34bf0cadb4.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJs5jIGm0z9IgRI36uKRbPHqo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_1ac46d02-d6aa-4838-82a6-2917e0313315",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "13171 GA-142, Covington, GA 30014, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-10c7-740b-a6d5-75e93b27d6e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9bb-10c7-740b-a6d5-75e93b27d6e9",
        "storage_key": "property/6767906449167571/019fa9bb-10c7-740b-a6d5-75e93b27d6e9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.homedepot.com/l/Covington/GA/Covington/30014/165?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=10455763989144091622&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "33.6152161",
      "poi_longitude": "-83.8257331",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 770-784-0197",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-470b-764c-95a5-ac75cb8fb035.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9bb-470b-764c-95a5-ac75cb8fb035",
        "storage_key": "property/6767906449167571/019fa9bb-470b-764c-95a5-ac75cb8fb035.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJB-VlAhUz9IgR5jtBfPNVGpE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_71c35781-ac9a-4845-bc93-47d52e0cf66f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "poi_name": "Flint Hill Elementary School",
      "poi_type": "Education",
      "poi_address": "1300 Airport Rd, Oxford, GA 30054, USA",
      "poi_short_description": "Public elementary school, Newton County Schools.",
      "poi_long_description": "Public elementary school, Newton County Schools.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://fhes.newtoncountyschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13220521036782765551&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "flint-hill-elementary-school",
      "poi_latitude": "33.6501324",
      "poi_longitude": "-83.8432417",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 770-784-2969",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-4705-716c-9ee5-f1f7f02bd231.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9bb-4705-716c-9ee5-f1f7f02bd231",
        "storage_key": "property/6767906449167571/019fa9bb-4705-716c-9ee5-f1f7f02bd231.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJBbGP2L409IgR7wUEb9a5eLc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_c80557dc-c3aa-4b4e-8788-5a392826b3a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "poi_name": "Cousins Middle School",
      "poi_type": "Education",
      "poi_address": "8187 Carlton Trail NW, Covington, GA 30014, USA",
      "poi_short_description": "Public middle school, Newton County Schools.",
      "poi_long_description": "Public middle school, Newton County Schools.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://cousinsms.newtoncountyschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9472254895486299780&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cousins-middle-school",
      "poi_latitude": "33.6124012",
      "poi_longitude": "-83.8790965",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 770-786-7311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-4705-716c-9ee5-f1f7f02bd231.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9bb-4705-716c-9ee5-f1f7f02bd231",
        "storage_key": "property/6767906449167571/019fa9bb-4705-716c-9ee5-f1f7f02bd231.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQRkOeuU09IgRhG5qK6Q1dIM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_d08e2084-5954-4cf4-819a-62d86e2c0904",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "poi_name": "Montessori School of Covington",
      "poi_type": "Education",
      "poi_address": "4108 Summers St, Covington, GA 30014, USA",
      "poi_short_description": "Private Montessori school.",
      "poi_long_description": "Private Montessori school.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bd-5540-73ec-b8d6-45e359e9c4c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9bd-5540-73ec-b8d6-45e359e9c4c6",
        "storage_key": "property/6767906449167571/019fa9bd-5540-73ec-b8d6-45e359e9c4c6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.montessori-covington.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2598858450550888373&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "montessori-school-of-covington",
      "poi_latitude": "33.5955299",
      "poi_longitude": "-83.8724178",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 770-788-7779",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-4705-716c-9ee5-f1f7f02bd231.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9bb-4705-716c-9ee5-f1f7f02bd231",
        "storage_key": "property/6767906449167571/019fa9bb-4705-716c-9ee5-f1f7f02bd231.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJs9LzgV409IgRtZebzv3_ECQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_be72cabe-bb2e-42ca-9b29-720abecd3d5a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "poi_name": "Peachtree Academy Covington Campus",
      "poi_type": "Education",
      "poi_address": "14101 US-278, Covington, GA 30014, USA",
      "poi_short_description": "Private school, Peachtree Academy's Covington campus.",
      "poi_long_description": "Private school, Peachtree Academy's Covington campus.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bd-57fe-741d-9fd0-9fac369f42b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9bd-57fe-741d-9fd0-9fac369f42b5",
        "storage_key": "property/6767906449167571/019fa9bd-57fe-741d-9fd0-9fac369f42b5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.peachtreeacademy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2957067895606309385&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "peachtree-academy-covington-campus",
      "poi_latitude": "33.5948928",
      "poi_longitude": "-83.8166983",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 770-860-8900 ext. 1003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-4705-716c-9ee5-f1f7f02bd231.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9bb-4705-716c-9ee5-f1f7f02bd231",
        "storage_key": "property/6767906449167571/019fa9bb-4705-716c-9ee5-f1f7f02bd231.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJp2_KE7oz9IgRCXJTdpWdCSk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_08273f3e-a32e-403d-ade6-f0c05b85d433",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "poi_name": "Legion Field - Covington Fairgrounds",
      "poi_type": "Entertainment",
      "poi_address": "3173 Mill St NE, Covington, GA 30014, USA",
      "poi_short_description": "Family-friendly venue featuring an ice rink, a track, a park, a bridge, and an open-air venue.",
      "poi_long_description": "Family-friendly venue featuring an ice rink, a track, a park, a bridge, and an open-air venue.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bd-58e0-775e-b9a5-d3a3bd21663d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9bd-58e0-775e-b9a5-d3a3bd21663d",
        "storage_key": "property/6767906449167571/019fa9bd-58e0-775e-b9a5-d3a3bd21663d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://legion-fairgrounds.keeq.io/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14965747871457491726&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "legion-field---covington-fairgrounds",
      "poi_latitude": "33.5981178",
      "poi_longitude": "-83.8510589",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-470e-7429-a7f8-6aa5cb988582.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9bb-470e-7429-a7f8-6aa5cb988582",
        "storage_key": "property/6767906449167571/019fa9bb-470e-7429-a7f8-6aa5cb988582.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI5MZL3409IgRDjtIrGUEsc8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_a0a0a5dd-a61f-457b-97e1-a735f106678e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "poi_name": "Porter Performing Arts Center",
      "poi_type": "Entertainment",
      "poi_address": "140 Ram Dr, Covington, GA 30014, USA",
      "poi_short_description": "Performing arts center hosting concerts, theatre and community events.",
      "poi_long_description": "Performing arts center hosting concerts, theatre and community events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bd-59b2-71cf-8949-1d278a4d8d6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9bd-59b2-71cf-8949-1d278a4d8d6d",
        "storage_key": "property/6767906449167571/019fa9bd-59b2-71cf-8949-1d278a4d8d6d.webp",
        "width": 1280,
        "height": 735
      },
      "poi_business_url": "http://www.newtoncountyarts.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8003093534555308026&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "porter-performing-arts-center",
      "poi_latitude": "33.583423",
      "poi_longitude": "-83.898012",
      "poi_miles_from_property": "6.4 mi",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-470e-7429-a7f8-6aa5cb988582.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9bb-470e-7429-a7f8-6aa5cb988582",
        "storage_key": "property/6767906449167571/019fa9bb-470e-7429-a7f8-6aa5cb988582.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_dOZIrc19IgR-v9k3yqzEG8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_cbc974d6-b74b-4373-b400-e93736aa2b2b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "poi_name": "Covington Visitors Center",
      "poi_type": "Entertainment",
      "poi_address": "1143 Oak St SE, Covington, GA 30014, USA",
      "poi_short_description": "Center with free admission, featuring exhibits from the filming of The Vampire Diaries along with other movie props and memorabilia.",
      "poi_long_description": "Center with free admission, featuring exhibits from the filming of The Vampire Diaries along with other movie props and memorabilia.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bd-5c5c-71ef-bb8b-dc9b04de1f92.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9bd-5c5c-71ef-bb8b-dc9b04de1f92",
        "storage_key": "property/6767906449167571/019fa9bd-5c5c-71ef-bb8b-dc9b04de1f92.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7038129136503839880&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "covington-visitors-center",
      "poi_latitude": "33.5951327",
      "poi_longitude": "-83.85720119999999",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-470e-7429-a7f8-6aa5cb988582.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9bb-470e-7429-a7f8-6aa5cb988582",
        "storage_key": "property/6767906449167571/019fa9bb-470e-7429-a7f8-6aa5cb988582.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP6tQ_vU19IgRiFyj-Ch1rGE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "visitor_center"
    },
    {
      "id": "custom_39de3709-16d0-4392-9def-53b216f067d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "poi_name": "AMC Conyers Crossing 16",
      "poi_type": "Entertainment",
      "poi_address": "1536 Dogwood Dr SE, Conyers, GA 30013, USA",
      "poi_short_description": "Cineplex with 3D & jumbo digital screens showing first-run films, opera productions & sports events.",
      "poi_long_description": "Cineplex with 3D & jumbo digital screens showing first-run films, opera productions & sports events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bd-5beb-771a-863f-c364d32ebe5a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9bd-5beb-771a-863f-c364d32ebe5a",
        "storage_key": "property/6767906449167571/019fa9bd-5beb-771a-863f-c364d32ebe5a.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/atlanta/amc-conyers-crossing-16?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=4833029694757446612&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-conyers-crossing-16",
      "poi_latitude": "33.6493322",
      "poi_longitude": "-83.9950282",
      "poi_miles_from_property": "11.7 mi",
      "poi_walking_minutes": "4 hours 15 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 770-929-0612",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bd-7fac-7039-b1c9-7fd68d26a4ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9bd-7fac-7039-b1c9-7fd68d26a4ee",
        "storage_key": "property/6767906449167571/019fa9bd-7fac-7039-b1c9-7fd68d26a4ee.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJKxRUmEpL9IgR1KPuoOZeEkM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_363f42d3-bf4a-4e5a-8cf1-cf9e71790ce4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "poi_name": "Georgia International Horse Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1996 Centennial Olympic Pkwy NE, Conyers, GA 30013, USA",
      "poi_short_description": "Equestrian venue and park built for the 1996 Olympic Games, with trails and event facilities.",
      "poi_long_description": "Equestrian venue and park built for the 1996 Olympic Games, with trails and event facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-4203-7378-af05-e75449ca83d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9bb-4203-7378-af05-e75449ca83d7",
        "storage_key": "property/6767906449167571/019fa9bb-4203-7378-af05-e75449ca83d7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.georgiahorsepark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1275071781745093866&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "georgia-international-horse-park",
      "poi_latitude": "33.662903",
      "poi_longitude": "-83.93198090000001",
      "poi_miles_from_property": "7.6 mi",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 770-860-4190",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-4727-725c-8004-e1b22acb61dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9bb-4727-725c-8004-e1b22acb61dd",
        "storage_key": "property/6767906449167571/019fa9bb-4727-725c-8004-e1b22acb61dd.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ83JZili19YgR6mwKpgf3sRE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_cdfad4b1-cd13-419f-81b3-ffecaa1ff7d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "poi_name": "Piedmont Newton",
      "poi_type": "Health and Wellness",
      "poi_address": "5126 Hospital Dr NE, Covington, GA 30014, USA",
      "poi_short_description": "Community hospital with an emergency department (Piedmont Healthcare).",
      "poi_long_description": "Community hospital with an emergency department (Piedmont Healthcare).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-2961-7179-a98f-3cb70185a6ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9bb-2961-7179-a98f-3cb70185a6ca",
        "storage_key": "property/6767906449167571/019fa9bb-2961-7179-a98f-3cb70185a6ca.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.piedmont.org/locations/piedmont-newton?utm_source=directorylisting&utm_medium=seo&utm_campaign=10223&y_source=1_MTI5OTY5MTItNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=12357037049121240309&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "piedmont-newton",
      "poi_latitude": "33.6013604",
      "poi_longitude": "-83.8478329",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 770-786-7053",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-4702-7309-8001-54a4e6c6eb33.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9bb-4702-7309-8001-54a4e6c6eb33",
        "storage_key": "property/6767906449167571/019fa9bb-4702-7309-8001-54a4e6c6eb33.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJH9lU1_Y09IgR9XQ2zbkDfas",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_fb9eac09-c516-4d4f-8ac0-1bdbfc350862",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "poi_name": "Peachtree Immediate Care - Covington North",
      "poi_type": "Health and Wellness",
      "poi_address": "12700 Town Center Dr #102, Covington, GA 30014, USA",
      "poi_short_description": "Walk-in urgent care clinic (Peachtree Immediate Care).",
      "poi_long_description": "Walk-in urgent care clinic (Peachtree Immediate Care).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bd-61e2-71b3-a9c5-e2d535b39f2b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9bd-61e2-71b3-a9c5-e2d535b39f2b",
        "storage_key": "property/6767906449167571/019fa9bd-61e2-71b3-a9c5-e2d535b39f2b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.peachtreemed.com/location/covington-north-urgent-care/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13012768991695718814&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "peachtree-immediate-care---covington-north",
      "poi_latitude": "33.622155",
      "poi_longitude": "-83.837949",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 678-712-8198",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-470e-7429-a7f8-6aa5cb988582.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9bb-470e-7429-a7f8-6aa5cb988582",
        "storage_key": "property/6767906449167571/019fa9bb-470e-7429-a7f8-6aa5cb988582.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA5rK0KEz9IgRnsk9DnSklrQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_efe5f1c2-1ae4-4e0a-9887-bdf17b4fb47d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "poi_name": "Piedmont Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "5239 Hwy 278 NE, Covington, GA 30014, USA",
      "poi_short_description": "Walk-in urgent care clinic in the Piedmont Healthcare network.",
      "poi_long_description": "Walk-in urgent care clinic in the Piedmont Healthcare network.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bd-615b-75e9-bf44-5af8e3de99e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9bd-615b-75e9-bf44-5af8e3de99e7",
        "storage_key": "property/6767906449167571/019fa9bd-615b-75e9-bf44-5af8e3de99e7.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.piedmonturgentcare.org/locations/covington-ga?location=118&utm_source=rioseo&utm_medium=local&utm_content=clinic_link_118",
      "poi_directions_map_url": "https://maps.google.com/?cid=4628986386777948273&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "piedmont-urgent-care",
      "poi_latitude": "33.6030621",
      "poi_longitude": "-83.84409760000001",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 678-660-5106",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-470e-7429-a7f8-6aa5cb988582.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9bb-470e-7429-a7f8-6aa5cb988582",
        "storage_key": "property/6767906449167571/019fa9bb-470e-7429-a7f8-6aa5cb988582.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxc6SGPkz9IgRccAE5pd2PUA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_209ab188-0aad-4c4b-afb4-6f3230ff9841",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "poi_name": "Publix Pharmacy at Covington Town Center",
      "poi_type": "Health and Wellness",
      "poi_address": "12701 Town Center Dr, Covington, GA 30014, USA",
      "poi_short_description": "Pharmacy inside the Publix at Covington Town Center.",
      "poi_long_description": "Pharmacy inside the Publix at Covington Town Center.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bd-608f-7749-9fb1-ec3f49410ce7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9bd-608f-7749-9fb1-ec3f49410ce7",
        "storage_key": "property/6767906449167571/019fa9bd-608f-7749-9fb1-ec3f49410ce7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.publix.com/pharmacy?utm_medium=maps&utm_source=google&utm_content=psmpharm_google_override",
      "poi_directions_map_url": "https://maps.google.com/?cid=4531733381018403734&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-pharmacy-at-covington-town-center",
      "poi_latitude": "33.623978",
      "poi_longitude": "-83.8391603",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 678-660-7132",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bd-7fe6-7584-b818-e37d911f4a15.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9bd-7fe6-7584-b818-e37d911f4a15",
        "storage_key": "property/6767906449167571/019fa9bd-7fe6-7584-b818-e37d911f4a15.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEVM7AmM09IgRlsNh-H_z4z4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_67f7700a-6b0a-491c-ab06-63d9d68c6a6d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "poi_name": "Alcovy Fitness & Wellness",
      "poi_type": "Health and Wellness",
      "poi_address": "10100 Alcovy Rd, Covington, GA 30014, USA",
      "poi_short_description": "Gym featuring weight and cardio equipment, group fitness classes, a heated pool, and a sauna.",
      "poi_long_description": "Gym featuring weight and cardio equipment, group fitness classes, a heated pool, and a sauna.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-263a-76da-b39b-5810dd61a541.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9bb-263a-76da-b39b-5810dd61a541",
        "storage_key": "property/6767906449167571/019fa9bb-263a-76da-b39b-5810dd61a541.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.alcovyfitness.com/membership",
      "poi_directions_map_url": "https://maps.google.com/?cid=6407240303023497525&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alcovy-fitness--wellness",
      "poi_latitude": "33.6162842",
      "poi_longitude": "-83.841838",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 770-385-8550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-470e-7429-a7f8-6aa5cb988582.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9bb-470e-7429-a7f8-6aa5cb988582",
        "storage_key": "property/6767906449167571/019fa9bb-470e-7429-a7f8-6aa5cb988582.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH6OYCIk09IgRNSFIzBsX61g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_24ffc1a1-f38c-40a8-b8b8-4d8ae9cd9d94",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "3173B Hwy 278 NE, Covington, GA 30014, USA",
      "poi_short_description": "Spacious, basic-equipment, judgment-free chain of gyms featuring circuit-training classes, weights and tanning beds.",
      "poi_long_description": "Spacious, basic-equipment, judgment-free chain of gyms featuring circuit-training classes, weights and tanning beds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-2001-77fe-9062-9680e897d3d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9bb-2001-77fe-9062-9680e897d3d3",
        "storage_key": "property/6767906449167571/019fa9bb-2001-77fe-9062-9680e897d3d3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/covington-ga?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=17745375139353358708&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "33.60455",
      "poi_longitude": "-83.85755999999999",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 470-444-1740",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-470e-7429-a7f8-6aa5cb988582.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9bb-470e-7429-a7f8-6aa5cb988582",
        "storage_key": "property/6767906449167571/019fa9bb-470e-7429-a7f8-6aa5cb988582.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf2GGOZ019IgRdHE0k6s8RPY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_0033d1cc-e60d-4ae2-afe7-108d696356c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "poi_name": "Covington Family YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "2140 Newton Dr NE, Covington, GA 30014, USA",
      "poi_short_description": "YMCA branch with fitness facilities, pool and family programs.",
      "poi_long_description": "YMCA branch with fitness facilities, pool and family programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bd-63d2-7426-b7c2-d9db7f1a7e55.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9bd-63d2-7426-b7c2-d9db7f1a7e55",
        "storage_key": "property/6767906449167571/019fa9bd-63d2-7426-b7c2-d9db7f1a7e55.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://ymcaatlanta.org/locations/covington-family-ymca?utm_source=google&utm_medium=local&utm_campaign=gbp_covington",
      "poi_directions_map_url": "https://maps.google.com/?cid=2661713259435739800&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "covington-family-ymca",
      "poi_latitude": "33.5990991",
      "poi_longitude": "-83.8522493",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 770-787-3908",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-470e-7429-a7f8-6aa5cb988582.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9bb-470e-7429-a7f8-6aa5cb988582",
        "storage_key": "property/6767906449167571/019fa9bb-470e-7429-a7f8-6aa5cb988582.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJed6Tj3009IgRmEqdahtO8CQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_172e0bca-6dde-43be-99ca-b904414bbb11",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "poi_name": "Newton County Turner Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6185 Turner Lake Rd NW, Covington, GA 30014, USA",
      "poi_short_description": "Park featuring a baseball field, nature trail, playground, and picnic tables, plus a fishing dock.",
      "poi_long_description": "Park featuring a baseball field, nature trail, playground, and picnic tables, plus a fishing dock.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-2ef2-757c-9ab0-fa3162ac55ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9bb-2ef2-757c-9ab0-fa3162ac55ee",
        "storage_key": "property/6767906449167571/019fa9bb-2ef2-757c-9ab0-fa3162ac55ee.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.co.newton.ga.us/Facilities/Facility/Details/Turner-Lake-1",
      "poi_directions_map_url": "https://maps.google.com/?cid=4940698479118887044&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "newton-county-turner-lake-park",
      "poi_latitude": "33.6002782",
      "poi_longitude": "-83.879499",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 770-786-4373",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-4727-725c-8004-e1b22acb61dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9bb-4727-725c-8004-e1b22acb61dd",
        "storage_key": "property/6767906449167571/019fa9bb-4727-725c-8004-e1b22acb61dd.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJl2Esevg09IgRhKgx_hbjkEQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_bae3e7c4-c98e-481c-83cc-a3e1dbefa051",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "poi_name": "Chimney Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8201 Hazelbrand Rd, Covington, GA 30014, USA",
      "poi_short_description": "Tranquil green space on a former estate with fitness trails & seasonal events & festivals.",
      "poi_long_description": "Tranquil green space on a former estate with fitness trails & seasonal events & festivals.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bd-6540-76be-9ff4-1cdf22f44ef5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9bd-6540-76be-9ff4-1cdf22f44ef5",
        "storage_key": "property/6767906449167571/019fa9bd-6540-76be-9ff4-1cdf22f44ef5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.chimney-park.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2865304505530439739&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chimney-park",
      "poi_latitude": "33.5979178",
      "poi_longitude": "-83.8388851",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 770-363-1983",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-4727-725c-8004-e1b22acb61dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9bb-4727-725c-8004-e1b22acb61dd",
        "storage_key": "property/6767906449167571/019fa9bb-4727-725c-8004-e1b22acb61dd.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJtzRYfXgz9IgRO9h3SUSbwyc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3c86c5aa-9c50-4b00-94f6-221069a4c9fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "poi_name": "Covington - Frank B Turner, Sr. Library",
      "poi_type": "Education",
      "poi_address": "7116 Floyd St NE, Covington, GA 30014, USA",
      "poi_short_description": "Public library with a decent selection of books, free Wi-Fi, and private rooms, plus a kids' area.",
      "poi_long_description": "Public library with a decent selection of books, free Wi-Fi, and private rooms, plus a kids' area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-1c15-7375-96e8-315167432b98.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9bb-1c15-7375-96e8-315167432b98",
        "storage_key": "property/6767906449167571/019fa9bb-1c15-7375-96e8-315167432b98.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://newtonlibraries.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5108389119926139728&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "covington---frank-b-turner-sr-library",
      "poi_latitude": "33.5993209",
      "poi_longitude": "-83.8389084",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 770-787-3231",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-4717-70d9-8fa5-ea814956e95b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9bb-4717-70d9-8fa5-ea814956e95b",
        "storage_key": "property/6767906449167571/019fa9bb-4717-70d9-8fa5-ea814956e95b.webp",
        "width": 192,
        "height": 174
      },
      "poi_google_place_id": "ChIJN4NEfXgz9IgRUPuq09ak5EY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_03b5993a-3dd5-48be-9536-4765a8388325",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "poi_name": "Lake Varner Reservoir",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Covington, GA 30014, USA",
      "poi_short_description": "Place to enjoy fishing and kayaking or boating, with playgrounds for kids.",
      "poi_long_description": "Place to enjoy fishing and kayaking or boating, with playgrounds for kids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-2b67-778b-9d24-32800ad1f34c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9bb-2b67-778b-9d24-32800ad1f34c",
        "storage_key": "property/6767906449167571/019fa9bb-2b67-778b-9d24-32800ad1f34c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.co.newton.ga.us/241/Lake-Varner",
      "poi_directions_map_url": "https://maps.google.com/?cid=6320992901137897288&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-varner-reservoir",
      "poi_latitude": "33.65223400000001",
      "poi_longitude": "-83.7995116",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 770-784-2049",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-4727-725c-8004-e1b22acb61dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9bb-4727-725c-8004-e1b22acb61dd",
        "storage_key": "property/6767906449167571/019fa9bb-4727-725c-8004-e1b22acb61dd.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJP3smVS_N9YgRSBcXtI2tuFc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3314ee46-6435-4322-ab77-5548585ec0a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "poi_name": "Academy Springs Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3120 Conyers St SE, Covington, GA 30014, USA",
      "poi_short_description": "A reservable pavilion can be used for private events at this compact park with a playground.",
      "poi_long_description": "A reservable pavilion can be used for private events at this compact park with a playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-2e33-75f3-8b68-9ab0977d1063.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9bb-2e33-75f3-8b68-9ab0977d1063",
        "storage_key": "property/6767906449167571/019fa9bb-2e33-75f3-8b68-9ab0977d1063.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://covingtongalions.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6395717069459934676&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "academy-springs-park",
      "poi_latitude": "33.5934111",
      "poi_longitude": "-83.8529811",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 770-786-4373",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-4727-725c-8004-e1b22acb61dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9bb-4727-725c-8004-e1b22acb61dd",
        "storage_key": "property/6767906449167571/019fa9bb-4727-725c-8004-e1b22acb61dd.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJN543B3w09IgR1M0P6ckmwlg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_457d259e-793e-4a82-85ea-03e302ce9455",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "poi_name": "Covington Park & Ride Lot",
      "poi_type": "Transportation & Transit",
      "poi_address": "6203 U.S.278 NW, Covington, GA 30014, USA",
      "poi_short_description": "Commuter park-and-ride lot serving the Covington area.",
      "poi_long_description": "Commuter park-and-ride lot serving the Covington area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bd-69aa-741a-abef-d9c637cc1a97.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9bd-69aa-741a-abef-d9c637cc1a97",
        "storage_key": "property/6767906449167571/019fa9bd-69aa-741a-abef-d9c637cc1a97.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=17770779328904071371&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "covington-park--ride-lot",
      "poi_latitude": "33.6063859",
      "poi_longitude": "-83.87592839999999",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bd-7fea-71f8-84ad-ff33217a4a6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9bd-7fea-71f8-84ad-ff33217a4a6d",
        "storage_key": "property/6767906449167571/019fa9bd-7fea-71f8-84ad-ff33217a4a6d.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJX2N4LvE09IgRy4guYaV9nvY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "custom_6a7b1af9-2b7a-4bee-829d-35bdc603f2ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "poi_name": "General Mills",
      "poi_type": "Major Employers & Offices",
      "poi_address": "15200 Industrial Park Blvd NE, Covington, GA 30014, USA",
      "poi_short_description": "General Mills manufacturing plant.",
      "poi_long_description": "General Mills manufacturing plant.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bd-70a9-708e-a13b-eac018e258ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9bd-70a9-708e-a13b-eac018e258ba",
        "storage_key": "property/6767906449167571/019fa9bd-70a9-708e-a13b-eac018e258ba.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.generalmills.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14552785493432688940&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "general-mills",
      "poi_latitude": "33.6233543",
      "poi_longitude": "-83.8238654",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 770-784-2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-470e-7429-a7f8-6aa5cb988582.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9bb-470e-7429-a7f8-6aa5cb988582",
        "storage_key": "property/6767906449167571/019fa9bb-470e-7429-a7f8-6aa5cb988582.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHQJHiEAz9IgRLGGDZE3h9ck",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_ca01ea0e-1a0f-4f3a-b27a-b3b9b1791547",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "poi_name": "Bridgestone Golf",
      "poi_type": "Major Employers & Offices",
      "poi_address": "15320 Industrial Park Blvd NE #6428, Covington, GA 30014, USA",
      "poi_short_description": "Bridgestone Golf headquarters and manufacturing facility.",
      "poi_long_description": "Bridgestone Golf headquarters and manufacturing facility.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bd-6e62-7662-b621-0863214200d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9bd-6e62-7662-b621-0863214200d0",
        "storage_key": "property/6767906449167571/019fa9bd-6e62-7662-b621-0863214200d0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.bridgestonegolf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13231881333715998322&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bridgestone-golf",
      "poi_latitude": "33.625122",
      "poi_longitude": "-83.8292388",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 770-787-7400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-470e-7429-a7f8-6aa5cb988582.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9bb-470e-7429-a7f8-6aa5cb988582",
        "storage_key": "property/6767906449167571/019fa9bb-470e-7429-a7f8-6aa5cb988582.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHTfkdBAz9IgRcpZDrvcVobc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_d4abcc95-4736-4938-b85f-5bdfa73a92d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "poi_name": "Newton County Schools",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2109 Newton Dr NE, Covington, GA 30014, USA",
      "poi_short_description": "Newton County Schools district office.",
      "poi_long_description": "Newton County Schools district office.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bd-7115-7319-9405-76b1bbb0676f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9bd-7115-7319-9405-76b1bbb0676f",
        "storage_key": "property/6767906449167571/019fa9bd-7115-7319-9405-76b1bbb0676f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.newtoncountyschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2400212768870972308&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "newton-county-schools",
      "poi_latitude": "33.5992136",
      "poi_longitude": "-83.85395070000001",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 770-787-1330",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-4705-716c-9ee5-f1f7f02bd231.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9bb-4705-716c-9ee5-f1f7f02bd231",
        "storage_key": "property/6767906449167571/019fa9bb-4705-716c-9ee5-f1f7f02bd231.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJhU_mRoc09IgRlDvp4ctETyE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b3f88ba4-8f66-4bec-8d1f-38297e6a9168",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "poi_name": "Georgia Piedmont Technical College",
      "poi_type": "Education",
      "poi_address": "16200 Alcovy Rd, Covington, GA 30014, USA",
      "poi_short_description": "Technical college campus in Covington (Georgia Piedmont Technical College).",
      "poi_long_description": "Technical college campus in Covington (Georgia Piedmont Technical College).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bd-7818-728c-b206-7e32213a0318.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9bd-7818-728c-b206-7e32213a0318",
        "storage_key": "property/6767906449167571/019fa9bd-7818-728c-b206-7e32213a0318.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.gptc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14632343028473608321&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "georgia-piedmont-technical-college",
      "poi_latitude": "33.6290897",
      "poi_longitude": "-83.82459209999999",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 770-786-9522",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bb-4705-716c-9ee5-f1f7f02bd231.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9bb-4705-716c-9ee5-f1f7f02bd231",
        "storage_key": "property/6767906449167571/019fa9bb-4705-716c-9ee5-f1f7f02bd231.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJyyTP70cz9IgRgTjVe3WGEMs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    }
  ],
  "office_hours": [
    {
      "id": "ec_bb44182c1f95f76b340a19ec",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_9f8f60547ba5aca75b158f9c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_439333fc76a09933139d9d90",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_e1380e8c4117d616a868d017",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_f61162560864bd4067387d18",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_c5a5c18839a261951f42f7cb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "16:00"
    }
  ],
  "reviews": [],
  "virtual_tours": [],
  "faqs": [
    {
      "id": "custom_2cfe8611-1676-4e83-8795-3a193afabea3",
      "question": "Application Fee",
      "answer": "$100 per person for all occupants over 18.",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_298518cb-5fc7-4625-9790-126f67cb9566",
      "question": "Administration Fee & Additional Charges",
      "answer": "A one-time administration fee of $350 is required at move-in. Please review the information below regarding additional charges and fees that may arise throughout your lease term.",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_17e9c000-c428-4199-9a2c-87a8679bcf79",
      "question": "Utility Billing Fee",
      "answer": "$11.99/month",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_b0e49074-e57c-4e33-aa25-642c6de6a83c",
      "question": "Pet Fees",
      "answer": "Non-refundable pet fee of $300 for one pet ($500 for two pets). Pet rent $35/month per pet",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_8b9b0d99-7273-43cb-9020-3632f7e9d09c",
      "question": "Concierge Package",
      "answer": "$10.95/month Bi-annual filter change Exterior pest control 24 hour maintenance response on emergencies Positive credit reporting",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_b9d665d8-ef75-4a0f-a75f-47d7ea6c7009",
      "question": "Smart Home",
      "answer": "Smart Home Fee - $35/month",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_65940525-56e1-4e96-94b0-dc2831ad2650",
      "question": "Trash",
      "answer": "Valet Trash $25/month",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_772cf39e-38ec-4b4e-8116-59b001438401",
      "question": "Landscape Services",
      "answer": "Townhomes: $45/month",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_d523312a-66f1-4faa-af96-2513b93d6cde",
      "question": "Occupancy Guidelines",
      "answer": "The maximum occupancy for Quinn properties is two (2) persons per bedroom, plus one (1) additional occupant per home. Occupancy standards may vary by region based on local city, county, and state laws.",
      "category": "Application Requirements",
      "source": "custom"
    },
    {
      "id": "custom_a9fff019-f0bb-444d-bcbe-8d44f1a82108",
      "question": "Application",
      "answer": "All adults, 18 years of age, or considered an adult under state law, are required to complete an application in its entirety. All occupants applying for the property must reside in the property. By acknowledging the terms and conditions outlined in the Quinn rental criteria, the Applicant confirms all information provided is true and accurate. Any falsification, fabrication, or untruthful answers and supporting documentation shall result in an automatic denial. Applicants are required, unless otherwise noted, to pay a $100.00 non-refundable application fee to authorize a background check and additional qualification processes; Properties may not be held off the market for greater than ten (10) days, unless a Quinn representative approves an extension. All applicants are required, unless otherwise specified, to pay a non-refundable $350 administration fee to secure a specific home and remove it from the market. All administration fees are non-refundable unless the application is declined. Upon Applicant approval, Leases are required to be signed within 24 hours of generation. In the event Lease is not signed within the 24-hour time Quinn may elect to cancel the application and place the home back on the market. All Applicants are required to provide valid identification. Non-US citizens applying to a home may be required to present information acknowledging the individual's right to live in the United States through the duration of the lease term. Approved applications are valid for thirty (30) days, after that time period, all Applicants must provide written consent for additional screening, credit checks, income verification, and re-qualification for a property managed by Quinn PM LLC. Any application that provides falsified or incorrect information may be subject to automatic disqualification. If an Applicant falsifies their application or supporting documentation, Quinn has the right to hold all deposits and fees paid to apply towards liquidated damages. DISCLAIMER: Rentgrow reports information about applicants in accordance with the applicable state and federal law. However, other federal, state or local laws and regulations may apply. This application, even if accepted, shall under no circumstances be considered a lease agreement between Applicant and Quinn, nor an offer to lease, and does not create a landlord/tenant relationship. No lease shall exist between an Applicant and Quinn unless and until the parties enter a fully executed Lease Agreement conditioned on the Applicant paying all required fees, security deposits, and rent. At Quinn PM LLC's sole discretion, Quinn PM LLC reserves the right to cancel an approved application, and refuse occupancy to any applicant(s) who disrupts or interferes with Landlord's business operations, or communicates with Landlord, Landlord's agents, or their employees in an unreasonable, discourteous, rude, or hostile manner.",
      "category": "Application Requirements",
      "source": "custom"
    },
    {
      "id": "custom_8906cf5c-0a32-4fe4-99b0-499d7f0b470d",
      "question": "Guarantors",
      "answer": "Guarantors may be accepted to support an application and must complete all required application and screening processes. Applicants who do not independently meet qualification criteria may also have the option to utilize a third-party lease guarantee program through TheGuarantors, which does not add an additional occupant or leaseholder.",
      "category": "Application Requirements",
      "source": "custom"
    },
    {
      "id": "custom_085a1b70-a3e8-4264-9eec-de61f49f2c78",
      "question": "Income",
      "answer": "Income Requirements: Household income requirements are based upon the market and other qualification factors within the application process. In-State Income Verification: Proof of income being made in the state where you are wishing to rent a home is required. Examples include, but are not limited to, state taxes shown on your pay statements, an offer letter or transfer letter confirming you are beginning a new role in that state, or proof that you are a remote employee. Job Transfer/New Role: Applicants with an offer of employment or transfer of role from their existing employer are required to provide an Offer Letter or Transfer Letter on employer letterhead confirming terms of compensation and start date. The letter should be signed and dated by the offeror. Contract-Based Employment: At select communities, an additional income verification option may be available for applicants working on a contract basis. This may include providing a notarized letter on company letterhead confirming income from Human Resources, Payroll, the business owner, or a company officer. Additional documentation may be required to verify the stated income. Additional Income Sources: Social Security Benefits, Child Support, Alimony, Disability, Retirement, Pensions, VA Benefits and complete Bank Statements are accepted. Items containing redacted or otherwise altered information are subject to additional verification and/or denial. Additional Documentation: Quinn may request additional proof of income if the documents provided are insufficient. False or Altered Documentation: Applicants who provide any false, counterfeit, or other fake documentation are subject to denial, even if discovered after approval. Any falsified documents will result in a denial.",
      "category": "Credit & Finance",
      "source": "custom"
    },
    {
      "id": "custom_e3af7876-ef77-4b4a-ac7d-bcba4a19dfc5",
      "question": "Security Deposit",
      "answer": "An applicant's security deposit is determined by the score of the applicant and may result in an increased security deposit for approval.",
      "category": "Credit & Finance",
      "source": "custom"
    },
    {
      "id": "custom_72306234-0f22-4b29-9629-3217c7dabec8",
      "question": "Credit Report",
      "answer": "All applicant's credit history enters a scoring model to determine qualifications for each application. The SafeRent Score is determined from an analysis of information found in each applicant's consumer credit report, application, and previous rental histories (if applicable). Consumer reports may include but are not limited to payment history, bankruptcies, number and type of accounts, collection activity, outstanding debt and credit inquiries. In addition, the scoring process includes income-to-rent ratio, eviction records, and subprime credit records. Current Open Bankruptcies (Chapter 7 or 13) will result in an automatic denial. Applicants are subject to further verification at the request of a Quinn representative. For applications in the state of South Carolina: Applicant(s) does hereby consent upon completion and meeting the criteria of a credit and rental history screening, a criminal background report will be processed by Quintasen Holdings, LLC to complete screening of the consumer information report.",
      "category": "Credit & Finance",
      "source": "custom"
    },
    {
      "id": "custom_5e1cedd1-be68-45dc-9cb9-a72ed78ed430",
      "question": "Rental History",
      "answer": "Prior Evictions, filed or enforced, may result in an automatic denial of the application. Any outstanding debt or judgment owed to any prior landlord may result in a denial. Quinn may request rental verification if rental history cannot be verified.",
      "category": "Leasing History",
      "source": "custom"
    },
    {
      "id": "custom_02409140-9ed5-4bfd-b105-2de92552201a",
      "question": "Criminal History",
      "answer": "Each Applicant is subject to a criminal background check. Criminal background screening is broken into the following categories 1) Crimes Against Persons, 2) Property, and 3) Society. Criminal histories presented through applicant screening reports pertaining to weapons, drugs, violence, or any other act that poses a threat to household, neighborhood, vendors, Quinn employees, or the physical property itself, may result in a denial. Criminal history will be assessed on the risk to persons or property by an applicant including but not limited to the type of crime; the severity of the crime; circumstance of the crime; and the length of time since the crime occurred. Denied Applicants may dispute any wrongful record claims by contacting Screening Works and following the process as outlined in their action letter and Screening Works. Criminal background screening is also governed by federal, state or local laws which regulate Quinn's screening processes. An Office of Foreign Assets Control (OFAC) search is completed for each Applicant. If Applicant appears on the OFAC list, the application will be denied.",
      "category": "Leasing History",
      "source": "custom"
    },
    {
      "id": "custom_b0222e21-62da-4795-878e-2e394a0cc685",
      "question": "Pets",
      "answer": "Pet Screening: Mandatory for all applicants before move-in. Pet Restrictions: Restricted breeds include Pit Bull, Rottweiler, Cane Corso, American Staffordshire Terrier, Bull Terrier, and American Bulldog, or any crossbreeds of these. Maximum weight limit of 100 pounds per pet. No more than two (2) pets allowed unless written approval is obtained from Quinn Property Management. Fees: Non-refundable pet fee of $300 for one pet; $500 for up to two pets. Monthly pet rent of $35 per pet. Prohibited Animals: Dangerous or poisonous animals and exotic pets are not permitted. Fish Tanks: Limited to 20 gallons. No pet fee or pet rent required for fish. Assistive Animals: Animals assisting persons with disabilities are exempt from these restrictions and are not considered pets. Vaccinations and Registrations: All pets must have up-to-date vaccinations and current state, city, and county registrations. Visiting Animals: No visiting animals allowed under any circumstances.",
      "category": "Pets & Animals",
      "source": "custom"
    },
    {
      "id": "custom_2f44f246-198e-4543-a1cc-d350e67834c8",
      "question": "Assistance Animals",
      "answer": "No Cost - Pet screening is mandatory as part of the application process prior to move in with a 2-5 business day approval turnaround time. Assistive Animals for persons with disabilities are not considered to be pets and are not subject to the pet restrictions bestowed in this section.",
      "category": "Pets & Animals",
      "source": "custom"
    },
    {
      "id": "custom_69b762ac-bc23-4847-934e-d916fd6e1575",
      "question": "Vehicles",
      "answer": "No more than four (4) vehicles are permitted on the Premises. Vehicles must be operational and have current and valid registration based upon state law. Additional HOA restrictions may apply to the number of vehicles, commercial vehicles and allowed parking locations. If your home is contained in an HOA review the HOA's restrictive covenants for more information regarding vehicle guidelines.",
      "category": "Vehicles",
      "source": "custom"
    },
    {
      "id": "custom_d64d0110-dcfd-453b-876c-f8cb23579f21",
      "question": "Renters Insurance",
      "answer": "To alleviate concerns and help you protect what matters most we have partnered with Assurant, a preferred insurance provider, to make the process of protecting your home and property seamless. We know how busy life can be, and we wanted to provide you an option that makes the selection of an insurance policy simple, while meeting your lease requirements. Please visit this page for more information on renters insurance requirements.",
      "category": "Renters Insurance",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [
    {
      "id": "ec_0ee7770448b8c03b8c9a292d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "yardi",
      "external_id": "2495238",
      "pet_type": "all",
      "allowed": true,
      "max_count": 3,
      "weight_limit": 0,
      "deposit": 0,
      "fee": 300,
      "monthly_rent": 35,
      "description": "false",
      "restrictions": "Contact Management"
    },
    {
      "id": "ec_12f3598af24ff08dea505589",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "yardi",
      "external_id": "2495236",
      "pet_type": "cats",
      "allowed": true,
      "max_count": 3,
      "weight_limit": 0,
      "deposit": 0,
      "fee": 300,
      "monthly_rent": 35,
      "description": "false",
      "restrictions": "false"
    },
    {
      "id": "ec_f27d2ae2d61c052b65f638b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "yardi",
      "external_id": "2495237",
      "pet_type": "dogs",
      "allowed": true,
      "max_count": 3,
      "weight_limit": 0,
      "deposit": 0,
      "fee": 300,
      "monthly_rent": 35,
      "description": "false",
      "restrictions": "false"
    }
  ],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0abe0-a4f2-741d-8cf9-a9d30bdae83e",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "The Forum Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571"
    },
    {
      "lead_collector_id": "01a0abe0-a572-74be-bd7e-df144e6289d7",
      "lead_source": "LANDING_PAGE",
      "name": "The Forum Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-covington-ga-forum",
      "search_query": "pet friendly apartments Covington GA",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Covington, GA",
      "h2_subtitle": "Discover pet friendly living at The Forum. Enjoy modern amenities and a welcoming community in Covington, GA.",
      "page_copy": "Looking for pet-friendly townhomes in Covington, GA? Discover The Forum, a welcoming rental community offering spacious three- and four-bedroom townhomes, modern features, and convenient access to local attractions throughout Newton County. With a pet-friendly policy and thoughtfully designed living spaces, The Forum offers a comfortable place to call home for you and your four-legged companions.\n\nInside your townhome, enjoy smart-home technology, stainless steel appliances, and in-unit laundry designed to simplify your everyday routine. Beyond your front door, take advantage of inviting community amenities, including a clubhouse and outdoor firepit, or explore nearby parks and outdoor spaces around Covington. Experience the convenience of modern townhome living at The Forum. Contact our leasing team to learn more about our pet policies and schedule an in-person tour today!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in Covington, GA",
      "seo_description": "Discover pet-friendly townhomes in Covington, GA, at The Forum, featuring smart-home technology, stainless steel appliances, and modern comforts. Explore today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "page_item_url": "apartments-with-pools-newton-county-forum",
      "search_query": "apartments with pools Newton County",
      "category": "Amenity",
      "h1_title": "Apartments with Pools in Newton County",
      "h2_subtitle": "Find top-notch apartments with pools in Newton County. Enjoy superb living at The Forum, offering luxury amenities and a vibrant community.",
      "page_copy": "Dive into a luxurious lifestyle at The Forum, where you can find apartments with pools in Newton County. Relax and unwind by our elegant pool area, the perfect spot for a refreshing swim or sunbathing on a warm day. Our community embraces comfort and style, making it an ideal choice for those seeking a relaxing living environment.\n\nIn addition to our exquisite pool, The Forum boasts a wide array of exceptional amenities. Enjoy the convenience of in-unit laundry, smart-home technology, and stainless steel appliances. Whether you're hosting friends in our sparkling clubhouse or relaxing by the firepit, The Forum offers everything you need. Experience life in Covington, GA, where modern living meets southern charm.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pools in Newton County",
      "seo_description": "Discover Newton County's best apartments with pools at The Forum. Enjoy luxurious living with smart-home features and vibrant amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "page_item_url": "luxury-apartments-near-30014-forum",
      "search_query": "luxury apartments near 30014",
      "category": "Amenity",
      "h1_title": "Luxury Apartments Near 30014",
      "h2_subtitle": "Explore luxury apartments near the 30014 area. The Forum offers superior amenities and stylish living in Covington, GA.",
      "page_copy": "Discover modern comfort and style at The Forum, offering luxury townhomes for rent in Covington, GA 30014. Our community features spacious three- and four-bedroom townhomes with thoughtfully designed interiors, stainless steel appliances, smart-home technology, and in-unit laundry. From contemporary finishes to everyday conveniences, each home offers features designed to complement your lifestyle.\n\nBeyond your front door, enjoy inviting community amenities, including a clubhouse and outdoor fire pit, providing comfortable spaces to relax or gather with neighbors. Conveniently located in Newton County, The Forum offers access to Covington's shopping, dining, parks, and local attractions. Experience the combination of modern townhome living and Southern charm at The Forum. Schedule a tour today and discover your next home in Covington, GA!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments Near 30014",
      "seo_description": "Find luxury apartments near 30014 at The Forum. Enjoy stylish living in Covington, GA, with premium amenities and modern comforts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "page_item_url": "smart-home-technology-apartments-covington-forum",
      "search_query": "smart home technology apartments Covington",
      "category": "Amenity",
      "h1_title": "Smart Home Technology Apartments in Covington",
      "h2_subtitle": "Discover smart home technology apartments in Covington at The Forum. Experience innovative living with advanced features and exceptional amenities.",
      "page_copy": "### Townhomes with Smart-Home Technology in Covington, GA\n\nDiscover modern townhomes with smart-home technology in Covington, GA, at The Forum. Our spacious three- and four-bedroom townhomes combine contemporary design with convenient features that make everyday living easier. Enjoy smart-home technology, stainless steel appliances, and in-unit laundry, all thoughtfully incorporated to bring comfort and functionality to your home.\n\nBeyond your front door, The Forum offers inviting community amenities, including a clubhouse and outdoor fire pit, where you can relax or spend time with neighbors. Located in Newton County, our community provides convenient access to Covington's shopping, dining, parks, and local attractions. Experience modern townhome living with innovative features and welcoming shared spaces. Schedule a tour today and discover everything The Forum has to offer!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Smart Home Technology Apartments in Covington",
      "seo_description": "Explore smart home technology apartments at The Forum in Covington, GA, offering innovative living with premium amenities and features.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "page_item_url": "apartments-in-unit-laundry-ga-forum",
      "search_query": "apartments with in-unit laundry GA",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in GA",
      "h2_subtitle": "Enjoy apartments with in-unit laundry in GA at The Forum. Discover a convenient lifestyle in Covington with modern amenities and stylish living spaces.",
      "page_copy": "### Townhomes with In-Unit Laundry in Covington, GA\n\nMake everyday living easier at The Forum, offering modern townhomes with in-unit laundry in Covington, GA. Our spacious three- and four-bedroom townhomes feature convenient in-home laundry, allowing you to take care of your laundry on your own schedule without relying on shared laundry facilities. Enjoy thoughtfully designed living spaces with modern features that bring comfort and convenience to your daily routine.\n\nBeyond the convenience of in-unit laundry, The Forum offers stainless steel appliances and smart-home technology to complement your lifestyle. Step outside your townhome and enjoy inviting community amenities, including a clubhouse and outdoor fire pit, where you can relax or spend time with neighbors. Located in Newton County, The Forum provides convenient access to Covington's shopping, dining, parks, and local attractions. Schedule a tour today and discover the convenience of modern townhome living in Covington, GA!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry in GA",
      "seo_description": "Discover GA living at The Forum, offering apartments with in-unit laundry, modern amenities, and a convenient lifestyle in Covington.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "page_item_url": "four-bedroom-apartments-covington-ga-forum",
      "search_query": "four bedroom apartments Covington GA",
      "category": "Floorplan",
      "h1_title": "Four Bedroom Apartments in Covington, GA",
      "h2_subtitle": "Explore spacious four bedroom apartments in Covington, GA at The Forum. Enjoy ample space and modern comforts in a vibrant community setting.",
      "page_copy": "Discover spacious four-bedroom townhomes for rent in Covington, GA, at The Forum. Our thoughtfully designed floor plans offer generous living spaces, comfortable bedrooms, and modern features that make it easy to feel at home. Whether you're enjoying a quiet evening or entertaining guests, these four-bedroom townhomes provide room to make the space your own.\n\nInside your townhome, enjoy stainless steel appliances, smart-home technology, and in-unit laundry, bringing convenience and functionality to your everyday routine. Beyond your front door, The Forum offers inviting community amenities, including a clubhouse and outdoor firepit, where you can relax or gather with neighbors. Conveniently located in Newton County, our community provides access to Covington's shopping, dining, parks, and local attractions. Schedule a tour today and explore our four-bedroom townhomes at The Forum!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Four Bedroom Apartments in Covington, GA",
      "seo_description": "Find spacious four bedroom apartments in Covington, GA at The Forum, offering modern amenities and a vibrant community lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-newton-county-forum",
      "search_query": "three bedroom apartments in Newton County",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Newton County",
      "h2_subtitle": "Discover three bedroom apartments in Newton County at The Forum. Spacious living, modern amenities, and a great location await you here.",
      "page_copy": "Discover spacious three-bedroom townhomes for rent in Covington, GA, at The Forum. Our thoughtfully designed floor plans offer comfortable living spaces, versatile bedrooms, and modern features that make it easy to feel at home. With room to relax, entertain, or create a dedicated workspace, our three-bedroom townhomes provide the flexibility to make each space your own.\n\nInside your townhome, enjoy smart-home technology, stainless steel appliances, and in-unit laundry, bringing everyday convenience to your routine. Beyond your front door, The Forum offers inviting community amenities, including a clubhouse and outdoor firepit, where you can unwind or gather with neighbors. Located in Newton County, our community provides convenient access to Covington's shopping, dining, parks, and local attractions. Schedule a tour today and explore our three-bedroom townhomes at The Forum!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Newton County",
      "seo_description": "Explore The Forum's three bedroom apartments in Newton County, offering modern amenities and a convenient Covington location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "page_item_url": "apartments-near-oxford-college-covington-forum",
      "search_query": "apartments near oxford college covington ga",
      "category": "School",
      "h1_title": "Apartments Near Oxford College, Covington GA",
      "h2_subtitle": "Find ideal apartments near Oxford College in Covington, GA at The Forum. Enjoy convenience and comfort located near campus.",
      "page_copy": "Discover modern townhomes near Oxford College of Emory University in Covington, GA, at The Forum. Our community offers spacious three- and four-bedroom townhomes with thoughtfully designed interiors and access to local shopping, dining, and attractions throughout Newton County. Enjoy modern home features, including smart-home technology, stainless steel appliances, and in-unit laundry, designed to bring comfort and convenience to your everyday routine.\n\nBeyond your front door, enjoy inviting community amenities, including a clubhouse and outdoor fire pit, where you can relax or spend time with neighbors. Explore nearby destinations, including Oxford College of Emory University, along with Covington's local restaurants, parks, and entertainment options. With modern townhome features, welcoming shared spaces, and a convenient Covington location, The Forum offers a place to feel right at home. Schedule a tour today and discover everything our Covington townhomes have to offer!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Oxford College, Covington GA",
      "seo_description": "Discover The Forum's modern apartments near Oxford College in Covington, GA—convenient living with top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "page_item_url": "apartments-near-georgia-state-perimeter-college-newton",
      "search_query": "apartments close to georgia state perimeter college newton 30014",
      "category": "School",
      "h1_title": "Apartments Near Georgia State Perimeter College",
      "h2_subtitle": "Discover apartments close to Georgia State Perimeter College Newton at The Forum. Enjoy modern amenities and a convenient Covington location.",
      "page_copy": "Discover modern townhomes near Georgia State University Perimeter College in Covington, GA, at The Forum. Located in Newton County, our community offers spacious three- and four-bedroom townhomes with thoughtfully designed interiors and convenient access to local shopping, dining, and attractions. Enjoy modern home features designed to bring comfort and convenience to your everyday routine.\n\nBeyond your front door, enjoy inviting community amenities, including a clubhouse and outdoor fire pit, where you can relax or gather with neighbors. Explore nearby destinations throughout Covington, including Georgia State University Perimeter College's Newton Campus, local parks, restaurants, and entertainment options. With modern townhome features, welcoming shared spaces, and access to the surrounding area, The Forum offers a comfortable place to call home. Schedule a tour today and discover our townhomes for rent in Covington, GA!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Georgia State Perimeter College",
      "seo_description": "Find apartments close to Georgia State Perimeter College Newton at The Forum, offering modern living in Covington, GA 30014.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "page_item_url": "apartments-near-piedmont-newton-hospital-covington",
      "search_query": "apartments near Piedmont Newton Hospital Covington GA",
      "category": "Hospital",
      "h1_title": "Apartments Near Piedmont Newton Hospital",
      "h2_subtitle": "Explore apartments near Piedmont Newton Hospital in Covington, GA. Enjoy comfort and convenience at The Forum, your perfect home base.",
      "page_copy": "Discover modern townhomes near Piedmont Newton Hospital in Covington, GA, at The Forum. Located in Newton County, our community offers spacious three- and four-bedroom townhomes with thoughtfully designed interiors and convenient access to local shopping, dining, and attractions. Enjoy modern home features designed to bring comfort and convenience to your everyday routine.\n\nBeyond your front door, enjoy inviting community amenities, including a clubhouse and outdoor fire pit, where you can relax or gather with neighbors. Explore nearby destinations throughout Covington, including Piedmont Newton Hospital, local parks, restaurants, and entertainment options. With spacious townhome layouts, welcoming shared spaces, and access to the surrounding area, The Forum offers a comfortable place to call home. Schedule a tour today and discover our townhomes for rent in Covington, GA!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Piedmont Newton Hospital",
      "seo_description": "Discover The Forum's apartments near Piedmont Newton Hospital, Covington GA. Modern living, prime location, and superb amenities await.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "page_item_url": "apartments-near-georgia-international-horse-park",
      "search_query": "apartments near georgia international horse park covington",
      "category": "Park",
      "h1_title": "Apartments Near Georgia International Horse Park",
      "h2_subtitle": "Find stylish apartments near Georgia International Horse Park in Covington. The Forum offers convenience and modern amenities.",
      "page_copy": "### Apartments Near Georgia International Horse Park in Covington, GA\n\nLooking for apartments near Georgia International Horse Park in Covington, GA? Discover The Forum, a welcoming rental community offering modern home features, inviting amenities, and convenient access to local attractions. Enjoy thoughtfully designed living spaces with smart-home technology, stainless steel appliances, and in-unit laundry that make everyday living more comfortable.\n\nBeyond your front door, The Forum offers community amenities designed for relaxation and connection. Spend time in the clubhouse, unwind by the outdoor fire pit, or explore nearby destinations like Georgia International Horse Park. From exciting equestrian events to outdoor recreation and local attractions, there's plenty to discover around Covington. Experience modern apartment living with the convenience of a desirable location. Schedule a tour of The Forum today!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Georgia International Horse Park",
      "seo_description": "Discover The Forum's modern apartments near Georgia International Horse Park, Covington. Convenience and top amenities await in this prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "page_item_url": "lake-varner-reservoir-nearby-apartments-30014",
      "search_query": "lake varner reservoir nearby apartments 30014",
      "category": "Park",
      "h1_title": "Lake Varner Reservoir Nearby Apartments",
      "h2_subtitle": "Explore nearby apartments to Lake Varner Reservoir in 30014. Enjoy serene living at The Forum with great amenities.",
      "page_copy": "### Townhomes Near Lake Varner Reservoir in Covington, GA\n\nDiscover modern townhomes near Lake Varner Reservoir in Covington, GA, at The Forum. Located in the 30014 area, our community combines thoughtfully designed living spaces with convenient access to Covington's outdoor attractions, shopping, and dining. Choose from spacious three- and four-bedroom townhomes featuring smart-home technology, stainless steel appliances, granite countertops, and in-unit laundry for everyday comfort and convenience.\n\nEnjoy inviting community amenities, including a clubhouse and outdoor firepit, or spend the day exploring the natural beauty of Lake Varner Reservoir and surrounding Covington attractions. Whether you're enjoying time outdoors or relaxing at home, The Forum offers a welcoming place to make the most of each day. Discover the convenience of modern townhome living in Covington, GA, and schedule a tour today!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Lake Varner Reservoir Nearby Apartments",
      "seo_description": "Find serenity at The Forum's nearby apartments to Lake Varner Reservoir, 30014. Modern amenities and prime location await.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "page_item_url": "apartments-around-city-pond-park-covington",
      "search_query": "apartments around city pond park covington ga",
      "category": "Park",
      "h1_title": "Apartments Around City Pond Park",
      "h2_subtitle": "Discover apartments around City Pond Park in Covington, GA. The Forum offers a perfect blend of location and amenities.",
      "page_copy": "Discover modern townhomes near City Pond Park in Covington, GA, at The Forum. Located in the 30014 area, our community offers spacious three- and four-bedroom townhomes with thoughtfully designed interiors and convenient access to local parks, shopping, and dining. Enjoy modern home features, including smart-home technology, stainless steel appliances, granite countertops, and in-unit laundry, designed to bring comfort and convenience to your everyday routine.\n\nBeyond your front door, enjoy inviting community amenities, including a clubhouse and outdoor fire pit, perfect for relaxing or gathering with neighbors. Explore City Pond Park, where recreational amenities include baseball fields, tennis courts, and outdoor spaces for enjoying time outside. With modern townhome features, convenient community amenities, and access to Covington's local attractions, The Forum offers a place to feel right at home. Schedule a tour today and discover everything our Covington townhomes have to offer!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Around City Pond Park",
      "seo_description": "Explore The Forum's ideal apartments around City Pond Park, Covington GA. Enjoy modern living and convenient amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "page_item_url": "turner-lake-park-apartments-covington",
      "search_query": "turner lake park apartments covington newton county",
      "category": "Park",
      "h1_title": "Turner Lake Park Apartments",
      "h2_subtitle": "Discover Turner Lake Park apartments in Covington, Newton County. Enjoy proximity and modern living at The Forum.",
      "page_copy": "### Townhomes Near Turner Lake Park in Covington, GA\n\nDiscover modern townhomes near Turner Lake Park in Covington, GA, at The Forum. Located in Newton County, our community offers thoughtfully designed living spaces with convenient access to local parks, outdoor recreation, shopping, and dining. Explore spacious three- and four-bedroom townhomes featuring smart-home technology, stainless steel appliances, and in-unit laundry, bringing modern comfort and convenience to your everyday routine.\n\nEnjoy inviting community amenities, including a clubhouse and outdoor firepit, where you can relax or spend time with neighbors. Beyond the community, Turner Lake Park offers opportunities to enjoy outdoor recreation and explore the natural beauty of Covington. With modern townhome features, welcoming shared spaces, and access to nearby attractions, The Forum combines convenience and comfort in a desirable Newton County location. Schedule a tour today and discover your next home at The Forum!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Turner Lake Park Apartments",
      "seo_description": "Find your home at The Forum's Turner Lake Park apartments in Covington, Newton County. Modern amenities and a prime location await.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167571",
      "source": "custom",
      "page_item_url": "apartments-close-to-academy-springs-park-ga",
      "search_query": "apartments close to academy springs park ga",
      "category": "Park",
      "h1_title": "Apartments Near Academy Springs Park",
      "h2_subtitle": "Find out about apartments near Academy Springs Park, GA. Experience comfort and proximity at The Forum.",
      "page_copy": "### Townhomes Near Academy Springs Park in Covington, GA\n\nDiscover modern townhomes near Academy Springs Park in Covington, GA, at The Forum. Our community offers spacious three- and four-bedroom townhomes with thoughtfully designed interiors and convenient access to local parks, shopping, dining, and outdoor recreation. Enjoy modern home features, including smart-home technology, stainless steel appliances, and in-unit laundry, designed to bring comfort and convenience to your everyday routine.\n\nBeyond your front door, enjoy inviting community amenities, including a clubhouse and outdoor fire pit, offering comfortable spaces to relax or gather with neighbors. Explore the outdoor spaces at Academy Springs Park and discover more of what Covington has to offer. With modern townhome features, convenient amenities, and access to local attractions, The Forum makes it easy to enjoy life in Newton County. Schedule a tour today and discover your next home at The Forum!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Academy Springs Park",
      "seo_description": "Discover The Forum's apartments near Academy Springs Park, GA. Modern amenities meet prime location in Covington.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12977250487"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-NZCJJ9B7"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 2"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "57159798433"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/d7p1mej8pkx"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/d43acf63-3ea0-4cfa-ab80-b264724e7d28/units"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "04d3b1f0-ff94-11ef-9bb4-e797342ea292"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "dba41761-2900-497b-8de7-41d7628b5018"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-623-4549"
    },
    {
      "ID": "custom_paid_social_tracking_phone_number",
      "type": "STRING",
      "value": "866-995-3141"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_repli_id": "12977250487",
  "custom_google_gtm_id": "GTM-NZCJJ9B7",
  "custom_rollout_phase": "Phase 2",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "full_stack",
  "custom_hubspot_company_id": "57159798433",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/d7p1mej8pkx",
  "custom_self_guided_tour_url": "https://selftournow.com/property/d43acf63-3ea0-4cfa-ab80-b264724e7d28/units",
  "custom_website_subscription": "custom",
  "custom_eliseai_building_token": "04d3b1f0-ff94-11ef-9bb4-e797342ea292",
  "custom_eliseai_organization_id": "dba41761-2900-497b-8de7-41d7628b5018",
  "custom_ppc_tracking_phone_number": "844-623-4549",
  "custom_paid_social_tracking_phone_number": "866-995-3141",
  "custom_audioeye_site_id": "52689024-60b3-476f-bf32-24353862bd3f",
  "custom_audioeye_site_hash": "6b383e603f909b34cfae01911a83b426"
};

export const generatedAt = '2026-10-29T18:36:08.978Z';
